<template>
    <div class="selectors osago-select osago-issue-page">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <div class="navsteps">
                        <div class="navsteps__item">
                            <div class="number">1</div>
                            <div class="descr">Розрахунок</div>
                        </div>
                        <div class="navsteps__item active">
                            <div class="number">2</div>
                            <div class="descr">Вибір СК</div>
                        </div>
                        <div class="navsteps__item">
                            <div class="number">3</div>
                            <div class="descr">Оформлення</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <div class="search-container">
                        <a class="searchpanel collapsed" data-toggle="collapse" data-target="#searchcollapse"
                           aria-expanded="false" aria-controls="#searchcollapse">
                            <span>Параметри пошуку</span>
                            <svg width="11" height="6" viewBox="0 0 11 6" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M10.2795 2.75059e-08L11 0.69496L5.5 6L-2.31891e-07 0.694961L0.7205 4.45343e-07L5.50275 4.61273L10.2795 2.75059e-08Z"
                                    fill="black"/>
                            </svg>
                        </a>
                        <div class="collapse" id="searchcollapse">
                            <OsagoSearchForm :data-customer-type-id="this.dataCustomerTypeId"
                                             :data-taxi="this.dataTaxi"
                                             :data-euro="this.dataEuro"
                                             :data-customer-privilege="this.dataCustomerPrivilege"
                                             :data-registration-place-id="this.dataRegistrationPlaceId"
                                             :data-car-kilometers = "this.dataCarKilometers"
                                             :data-car-birthday-at = "this.dataCarbirthdayAt"
                                             :data-car-year = "this.dataCarYear"
                                             :data-car-brand = "this.dataCarBrand"
                                             :data-car-vin = "this.dataCarVin"
                                             :data-car-age = "this.dataCarAge"
                                             :data-car-birth-date-owner = "this.dataCarBirthDateOwner"
                                             :data-car-model = "this.dataCarModel"
                                             :data-car-additional-parameters = "this.dataCarAdditionalParameters"
                                             :data-zone="this.dataZone"
                                             :data-insurance-registration-type="this.registrationType"
                                             :data-car-type-group="this.dataCarTypeGroup"
                                             :data-car-type="this.dataCarType"
                                             :data-car-type-option="this.dataCarTypeOption"
                                             :data-start-order="dataStartOrder"
                                             :data-otk="this.dataOtk"
                                             :data-car-number="this.dataCarNumber"
                                             :data-month-list="this.monthList"
                                             :data-period-id="this.dateInfo.period_id"
                                             :data-identification-code="this.dataIdentificationCode"
                                             :data-month-list-no-show="true"/>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row flex-lg-row-reverse">
                <div class="col-lg-4 osago-results-osago-info-resize">
                    <div class="sticky-wrapp">
                        <div class="scroll-wrap">
                            <ClientPropositionInfo
                                :is-mobile="isMobile"
                                :proposition-list="clientPropositionsList"
                                :showPropositionModal="showPropositionModal"
                                @clear-propositions="clearPropositions()"
                                @remove-proposition="removeClientProposition"
                                :product-type="1"
                                :search-params-data="osagoSearchParams"
                                :date-info-data="osagoDateInfo"
                            />
                            <OsagoPolicy can-edit="true"/>
                        </div>
                    </div>
                </div>
                <div class="col-lg-8">
                    <div class="osago-filters__wrapp">
                        <div :class="['filter-content-wrapp', {'active': activeClassWrapp}]">
                            <div class="filter-content-wrapp__heading"><span>Фільтр</span>
                                <button class="filter-content-close" @click="filterStatusWrapp();"></button>
                            </div>

<!--                            <div :class="['filter-row', 'dropdown', 'filter-row-franchise']">-->
<!--                                <div class="filter-title">-->
<!--                                    Франшиза-->
<!--                                </div>-->
<!--                                <button class="osago-tabs-toggle dropdown-toggle" id="dropdown-franchise"-->
<!--                                        data-toggle="dropdown" data-flip="false">-->
<!--                                    <span ref="toggleValueFranchise">-->
<!--                                        <span v-if="filters.franchises.length > 0 && filters.franchises.length < 2">{{-->
<!--                                                filters.franchises[0]-->
<!--                                            }} грн</span>-->
<!--                                        <span v-else-if="filters.franchises.length > 1">Обрано: {{-->
<!--                                                filters.franchises.length-->
<!--                                            }} </span>-->
<!--                                        <span v-else>Всі франшизи</span>-->
<!--                                    </span>-->
<!--                                </button>-->
<!--                                <div class="filter-body dropdown-menu" aria-labelledby="dropdown-franchise">-->
<!--                                    <div class="dropdown-menu__container">-->
<!--                                        <div class="large-checkbox osago-filter"-->
<!--                                             v-for="franchise in filters.franchiseList">-->
<!--                                            <input name="franchise" type="checkbox" :id="franchise" :value="franchise"-->
<!--                                                   v-model="filters.franchises">-->
<!--                                            <label :for="franchise">-->
<!--                                                <i class="icon icon-directSettlement"></i>-->
<!--                                                <span class="icon-text">{{ franchise }} грн.</span>-->
<!--                                            </label>-->
<!--                                        </div>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                            </div>-->

                            <div :class="['filter-row','filter-row-help', 'dropdown']">
                                <div class="filter-title">
                                    Опції
                                </div>
                                <button class="osago-tabs-toggle dropdown-toggle" id="dropdown-help"
                                        data-toggle="dropdown" data-flip="false">
                                    <span v-if="filters.optionsList.length > 0 && filters.optionsList.length < 2">{{
                                            filters.optionsList[0]
                                        }}</span>
                                    <span v-else-if="filters.optionsList.length > 1">Обрано: {{
                                            filters.optionsList.length
                                        }}</span>
                                    <span v-else ref="toggleValueHelp">Виберіть опції</span>
                                </button>
                                <div class="filter-body dropdown-menu" aria-labelledby="dropdown-help">
                                    <div class="row osago-filter-row" v-if="offers">
                                        <div class="col large-checkbox_box">
                                            <div class="large-checkbox osago-filter">
                                                <input type="checkbox" name="directSettlement"
                                                       v-model="filters.directSettlement" id="directSettlement"
                                                       @change="toggleOptions('Пряме врегулювання')">
                                                <label for="directSettlement">
                                                    <i class="icon icon-directSettlement"></i>
                                                    <span class="icon-text">Пряме врегулювання</span>
                                                </label>
                                            </div>
                                        </div>
                                        <div class="col large-checkbox_box">
                                            <div class="large-checkbox osago-filter">
                                                <input type="checkbox" name="supportEverytime"
                                                       v-model="filters.supportEverytime" id="supportEverytime"
                                                       @change="toggleOptions('Допомога 24/7')">
                                                <label for="supportEverytime">
                                                    <i class="icon icon-supportEverytime"></i> Допомога 24/7
                                                </label>
                                            </div>
                                        </div>
                                        <div class="col large-checkbox_box">
                                            <div class="large-checkbox osago-filter">
                                                <input type="checkbox" name="medicineHelp"
                                                       v-model="filters.medicineHelp" id="medicineHelp"
                                                       @change="toggleOptions('Медична допомога')">
                                                <label for="medicineHelp">
                                                    <i class="icon icon-medicineHelp"></i> Медична допомога
                                                </label>
                                            </div>
                                        </div>
                                        <div class="col large-checkbox_box" v-for="customOption in customOptions">
                                            <div class="large-checkbox osago-filter">
                                                <input type="checkbox" :value="customOption"
                                                       v-model.number="filters.customOptions" :id="customOption"
                                                       @change="toggleOptions(customOption)">
                                                <label :for="customOption" v-text="customOption"></label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div :class="['filter-row','filter-row-help', 'dropdown']">
                                <div class="filter-title">
                                    <span class="filter-title__heading">Компанії</span>
                                </div>
                                <button class="osago-tabs-toggle dropdown-toggle" id="dropdown-company"
                                        data-toggle="dropdown" data-flip="false">
                                    <span v-if="filters.company.length > 0 && filters.company.length < 2">{{
                                            filters.company[0]
                                        }}</span>
                                    <span
                                        v-else-if="filters.company.length > 1">Выбрано: {{
                                            filters.company.length
                                        }}</span>
                                    <span v-else>Відсортуйте компанії</span>
                                </button>
                                <div class="filter-body pl-0 dropdown-menu" aria-labelledby="dropdown-company">
                                    <div class="row osago-filter-row">
                                        <div class="col large-checkbox_box" v-if="offers">
                                            <div class="large-checkbox osago-filter" v-for="name in uniqueNames">
                                                <input type="checkbox" :value="name" :name="name" :id="name"
                                                       v-model="filters.company">
                                                <label :for="name">
                                                    <i class="icon icon-directSettlement"></i>
                                                    <span class="icon-text">{{ name }}</span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div :class="['filter-row','filter-row-price']">
                                <div class="filter-title">
                                    <span class="filter-title__heading">Ціна</span>
                                </div>
                                <div class="filter-price__wrapp">
                                    <div :class="['filter-price__form',{'active':focusedPriceDiapason}]">
                                        <input type="number" v-model="filters.priceDiapason.min"
                                               @focus="focusedPriceDiapason = true" @blur="focusedPriceDiapason = false"
                                               placeholder="мін">
                                        <span class="delimiter"></span>
                                        <input type="number" v-model="filters.priceDiapason.max"
                                               @focus="focusedPriceDiapason = true" @blur="focusedPriceDiapason = false"
                                               placeholder="макс" ref="priceMax">
                                    </div>
                                </div>
                            </div>
                            <button class="filter-content-apply" @click="filterStatusWrapp();">Застосувати</button>
                            <button class="filter-content-discard" @click="filterDiscard(); filterStatusWrapp();">
                                Скинути фільтр
                            </button>
                        </div>
                        <div class="osago-filters__toggle">
                            <button class="osago-filters__mobToggle__item" @click="filterStatusWrapp()">
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <rect y="1.25" width="20" height="2.5" rx="1.25" fill="#007BBB"></rect>
                                    <rect y="8.75" width="20" height="2.5" rx="1.25" fill="#007BBB"></rect>
                                    <rect y="16.25" width="20" height="2.5" rx="1.25" fill="#007BBB"></rect>
                                    <rect x="13.25" y="0.75" width="3.5" height="3.5" rx="1.25" fill="white"
                                          stroke="#007BBB" stroke-width="1.5"></rect>
                                    <rect x="12" y="15.75" width="3.5" height="3.5" rx="1.25" fill="white"
                                          stroke="#007BBB" stroke-width="1.5"></rect>
                                    <rect x="4.5" y="8.25" width="3.5" height="3.5" rx="1.25" fill="white"
                                          stroke="#007BBB" stroke-width="1.5"></rect>
                                </svg>
                                Фільтр
                            </button>
                            <div class="row align-items-center osago-sort-select">
<!--                              TODO включити коли повернуться питання з банками-->
<!--                                <div v-if="!$store.getters.USER_INFO.organizationId" class="osago-offers__earnings">-->
                                <div class="osago-offers__earnings">
                                    <button v-if="!showEarnings" @click="showEarnings = true" type="button">
                                        <svg style="margin-bottom: 5px" width="16" height="16"
                                             viewBox="0 0 16 16" fill="none"
                                             xmlns="http://www.w3.org/2000/svg">
                                            <g clip-path="url(#clip0)">
                                                <path
                                                    d="M0.666504 8C0.666504 8 3.33317 2.66667 7.99984 2.66667C12.6665 2.66667 15.3332 8 15.3332 8C15.3332 8 12.6665 13.3333 7.99984 13.3333C3.33317 13.3333 0.666504 8 0.666504 8Z"
                                                    stroke="#24282C" stroke-width="2" stroke-linecap="round"
                                                    stroke-linejoin="round"/>
                                                <path
                                                    d="M8 10C9.10457 10 10 9.10457 10 8C10 6.89543 9.10457 6 8 6C6.89543 6 6 6.89543 6 8C6 9.10457 6.89543 10 8 10Z"
                                                    stroke="#24282C" stroke-width="2" stroke-linecap="round"
                                                    stroke-linejoin="round"/>
                                            </g>
                                            <defs>
                                                <clipPath id="clip0">
                                                    <rect width="16" height="16" fill="white"/>
                                                </clipPath>
                                            </defs>
                                        </svg>
                                        <span>Показати заробіток</span>
                                    </button>
                                    <button v-if="showEarnings" @click="showEarnings = false" type="button">
                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                                             xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M9.11649 5.0665C9.4088 5.02169 9.70411 4.9994 9.99983 4.99983C12.6498 4.99983 15.1415 6.90816 16.5915 9.99983C16.3697 10.4703 16.1193 10.9267 15.8415 11.3665C15.7533 11.503 15.707 11.6623 15.7082 11.8248C15.71 12.0067 15.7713 12.183 15.8827 12.3267C15.9941 12.4705 16.1495 12.5739 16.3251 12.6211C16.5008 12.6683 16.687 12.6568 16.8555 12.5882C17.024 12.5197 17.1654 12.3979 17.2582 12.2415C17.6464 11.6314 17.9837 10.9904 18.2665 10.3248C18.3112 10.2208 18.3343 10.1088 18.3343 9.99566C18.3343 9.88248 18.3112 9.77048 18.2665 9.6665C16.5832 5.75816 13.4165 3.33316 9.99983 3.33316C9.60872 3.33119 9.21823 3.36466 8.83316 3.43316C8.72373 3.45177 8.61903 3.49174 8.52504 3.55081C8.43106 3.60988 8.34963 3.68688 8.2854 3.77741C8.22117 3.86795 8.17541 3.97025 8.15072 4.07848C8.12602 4.1867 8.12289 4.29873 8.1415 4.40816C8.1601 4.5176 8.20008 4.6223 8.25914 4.71628C8.31821 4.81027 8.39521 4.8917 8.48575 4.95592C8.57628 5.02015 8.67858 5.06592 8.78681 5.09061C8.89503 5.1153 9.00706 5.11843 9.11649 5.09983V5.0665ZM3.0915 1.90816C3.0138 1.83046 2.92155 1.76883 2.82004 1.72678C2.71852 1.68473 2.60971 1.66309 2.49983 1.66309C2.38995 1.66309 2.28114 1.68473 2.17962 1.72678C2.0781 1.76883 1.98586 1.83046 1.90816 1.90816C1.75124 2.06508 1.66309 2.27791 1.66309 2.49983C1.66309 2.72175 1.75124 2.93458 1.90816 3.0915L4.4915 5.6665C3.31281 6.8011 2.37471 8.16148 1.73316 9.6665C1.68728 9.77163 1.66359 9.88511 1.66359 9.99983C1.66359 10.1145 1.68728 10.228 1.73316 10.3332C3.4165 14.2415 6.58316 16.6665 9.99983 16.6665C11.4974 16.6561 12.9596 16.2102 14.2082 15.3832L16.9082 18.0915C16.9856 18.1696 17.0778 18.2316 17.1793 18.2739C17.2809 18.3162 17.3898 18.338 17.4998 18.338C17.6098 18.338 17.7188 18.3162 17.8203 18.2739C17.9219 18.2316 18.014 18.1696 18.0915 18.0915C18.1696 18.014 18.2316 17.9219 18.2739 17.8203C18.3162 17.7188 18.338 17.6098 18.338 17.4998C18.338 17.3898 18.3162 17.2809 18.2739 17.1793C18.2316 17.0778 18.1696 16.9856 18.0915 16.9082L3.0915 1.90816ZM8.39149 9.56649L10.4332 11.6082C10.2923 11.6486 10.1463 11.6682 9.99983 11.6665C9.5578 11.6665 9.13388 11.4909 8.82132 11.1783C8.50876 10.8658 8.33316 10.4419 8.33316 9.99983C8.33146 9.85332 8.35111 9.70734 8.39149 9.56649ZM9.99983 14.9998C7.34983 14.9998 4.85816 13.0915 3.4165 9.99983C3.9549 8.81129 4.71906 7.73864 5.6665 6.8415L7.1415 8.33316C6.79503 8.96549 6.66295 9.69312 6.76504 10.4069C6.86714 11.1206 7.19793 11.782 7.70777 12.2919C8.21761 12.8017 8.87902 13.1325 9.59278 13.2346C10.3065 13.3367 11.0342 13.2046 11.6665 12.8582L12.9915 14.1665C12.0841 14.7006 11.0527 14.9879 9.99983 14.9998Z"
                                                fill="#24282C"/>
                                        </svg>
                                        Сховати заробіток
                                    </button>
                                </div>
                                <div class="d-flex osago-sort-select__content">
                                    <p class="sort-type ml-lg-auto" @click="setOffersSortType">
                                        <span class="osago-sort-select__descr">Сортування:</span>
                                        <span class="osago-sort-select__toggleMob">
                              <svg width="20" height="18" viewBox="0 0 20 18" fill="none"
                                   xmlns="http://www.w3.org/2000/svg">
                                 <rect y="0.25" width="20" height="2.5" rx="1.25" fill="#007BBB"></rect>
                                 <rect y="7.75" width="16" height="2.5" rx="1.25" fill="#007BBB"></rect>
                                 <rect y="15.25" width="12" height="2.5" rx="1.25" fill="#007BBB"></rect>
                              </svg>
                              Сортування
                           </span>
                                        <select class="nice-select sort-select" v-model="filters.sort">
                                            <option value="price-earnings" data-display="Найвигідніші">
                                                <div class="d-flex justify-content-between">
                                                    <i class="icon pin save-default"></i>
                                                    <span>Найвигідніші</span>
                                                </div>
                                            </option>
                                            <option value="lowcost" data-display="Найдешевші">
                                                <div class="d-flex justify-content-between">
                                                    <i class="icon pin save-default"></i>
                                                    Найдешевші
                                                </div>
                                            </option>
                                            <option value="earnings" data-display="За заробітком">
                                                <div class="d-flex justify-content-between">
                                                    <i class="icon pin save-default"></i>
                                                    За заробітком
                                                </div>
                                            </option>
                                            <option value="name" data-display="За назвою компанії">
                                                <div class="d-flex justify-content-between">
                                                    <i class="icon pin save-default"></i>
                                                    За назвою компанії
                                                </div>
                                            </option>
                                            <option value="net-pay" data-display="За нетто-платежем">
                                                <div class="d-flex justify-content-between">
                                                    <i class="icon pin save-default"></i>
                                                    За нетто-платежем
                                                </div>
                                            </option>
                                        </select>
                                        <i class="icon pin-fill" style="display: unset"></i>
                                    </p>
                                </div>
                                <div class="osago-sort-view">
                                    <span>Вид:</span>
                                    <button class="toggler-view-second" @click="viewSecondAdd('result-second')">
                                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none"
                                             xmlns="http://www.w3.org/2000/svg">
                                            <rect width="8" height="8" rx="2" fill="#999DA6"/>
                                            <rect x="10" width="8" height="8" rx="2" fill="#999DA6"/>
                                            <rect x="10" y="10" width="8" height="8" rx="2" fill="#999DA6"/>
                                            <rect y="10" width="8" height="8" rx="2" fill="#999DA6"/>
                                        </svg>
                                    </button>
                                    <button class="toggler-view-default active"
                                            @click="viewSecondRemove('result-second')">
                                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none"
                                             xmlns="http://www.w3.org/2000/svg">
                                            <line x1="8.74229e-08" y1="1" x2="18" y2="1" stroke="#999DA6"
                                                  stroke-width="2"/>
                                            <line x1="8.74229e-08" y1="9" x2="18" y2="9" stroke="#999DA6"
                                                  stroke-width="2"/>
                                            <line x1="8.74229e-08" y1="17" x2="18" y2="17" stroke="#999DA6"
                                                  stroke-width="2"/>
                                        </svg>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row results">
                        <!---->
                        <div class="col-12 position-relative" v-if="!offers">
                            <div class="results_anime">
                                <div class="results_anime_circles">
                                    <div class="waiting_animation">
                                        <div class="background">
                                            <div class="loader loader-left"></div>
                                            <div class="loader loader-right"></div>
                                        </div>
                                    </div>
                                </div>
                                <div class="results_anime_percent">
                                    <span class="results_anime_percent-text"></span>
                                </div>
                                <div class="results_anime_line">
                                    <span class="results_anime_line-scale" :style="`width: 1%;`"></span>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 position-relative" v-if="offers">
                            <div class="results-fixed-header">
                                <div class="osago-offers__heading">
                                    <div class="osago-offers__title">
                                        <h3>Знайдено: {{ offers.length }}</h3>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 result-list new-list" v-if="offers">
                            <div class="result-article" v-for="(offer, index) in offers" :key="index">
                                <div class="result-article__wrapp">
                                    <div style="display: none;">Это кросс {{ isCrossProduct(offer) }}</div>
                                    <div
                                        :class="['result-item', {'result-item-rated':offer.company.mtsbuRating != null}]">
                                        <div class="result-wrapp">
                                            <div class="result__info">
                                                <div class="result__logo">
                                                    <img v-if="offer.company.logo" :src="offer.company.logo" alt="logo">
                                                    <img v-else src="images/aboutUs-insurance_icon.svg" alt="logo">
                                                </div>
                                                <div class="result__info__main">
                                                    <div class="result__name">
                                                        <h5>{{ offer.company.publicName }}</h5>
                                                        <span class="mtsbu-icon" data-placement="bottom"
                                                              data-toggle="tooltip" title="">
                                                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none"
                                                                 xmlns="http://www.w3.org/2000/svg">
                                                                <circle
                                                                    v-if="offer.company.mtsbuRating.paramAssessment > 4"
                                                                    cx="8" cy="8" r="8" fill="#00B52C"/>
                                                                <circle
                                                                    v-if="offer.company.mtsbuRating.paramAssessment > 3 && offer.company.mtsbuRating.paramAssessment < 5"
                                                                    cx="8" cy="8" r="8" fill="#FFB200"/>
                                                                <circle
                                                                    v-if="offer.company.mtsbuRating.paramAssessment < 3"
                                                                    cx="8" cy="8" r="8" fill="#EF4137"/>
                                                                <path
                                                                    d="M4.75736 11.4853L11.1213 5.12132M11.1213 5.12132H6.87868M11.1213 5.12132L11.2427 9.24256"
                                                                    stroke="white" stroke-width="1.5"/>
                                                            </svg>
                                                        </span>
                                                    </div>
                                                    <div class="result__rating"
                                                         v-html="showRatingStars(offer.company.rating)">
                                                    </div>
                                                    <div v-if="offer.hasCompanyBranch" class="result__department">
                                                        <a @click="showCompanyBranches(offer)"
                                                           href="javascript:void(0)">
                                                            <svg width="12" height="16" viewBox="0 0 12 16" fill="none"
                                                                 xmlns="http://www.w3.org/2000/svg">
                                                                <path fill-rule="evenodd" clip-rule="evenodd"
                                                                      d="M8.84798 6.84758C8.84798 7.55482 8.56703 8.2331 8.06693 8.73319C7.56684 9.23329 6.88856 9.51424 6.18131 9.51424C5.47407 9.51424 4.79579 9.23329 4.2957 8.73319C3.7956 8.2331 3.51465 7.55482 3.51465 6.84758C3.51465 6.14033 3.7956 5.46205 4.2957 4.96196C4.79579 4.46186 5.47407 4.18091 6.18131 4.18091C6.88856 4.18091 7.56684 4.46186 8.06693 4.96196C8.56703 5.46205 8.84798 6.14033 8.84798 6.84758ZM7.51465 6.84758C7.51465 7.2012 7.37417 7.54034 7.12412 7.79038C6.87408 8.04043 6.53494 8.18091 6.18131 8.18091C5.82769 8.18091 5.48855 8.04043 5.23851 7.79038C4.98846 7.54034 4.84798 7.2012 4.84798 6.84758C4.84798 6.49395 4.98846 6.15481 5.23851 5.90477C5.48855 5.65472 5.82769 5.51424 6.18131 5.51424C6.53494 5.51424 6.87408 5.65472 7.12412 5.90477C7.37417 6.15481 7.51465 6.49395 7.51465 6.84758Z"
                                                                      fill="#009BEB"/>
                                                                <path fill-rule="evenodd" clip-rule="evenodd"
                                                                      d="M1.86267 11.0119C1.00323 10.1936 0.405739 9.13884 0.14576 7.98098C-0.11422 6.82312 -0.0250142 5.61416 0.402097 4.507C0.829208 3.39983 1.57504 2.44419 2.54528 1.76091C3.51552 1.07762 4.66659 0.697397 5.85292 0.668308C7.03926 0.639218 8.20758 0.962572 9.21014 1.59748C10.2127 2.23239 11.0045 3.15033 11.4853 4.23523C11.9662 5.32013 12.1146 6.52326 11.9116 7.69248C11.7087 8.86169 11.1636 9.94447 10.3453 10.8039L6.208 15.1492L1.86267 11.0119ZM9.38 9.88457L6.162 13.2646L2.782 10.0466C2.11358 9.41012 1.64889 8.58976 1.4467 7.68922C1.24451 6.78868 1.31389 5.8484 1.64608 4.9873C1.97827 4.12619 2.55833 3.38292 3.31294 2.85148C4.06754 2.32004 4.96278 2.02429 5.88547 2.00163C6.80815 1.97898 7.71683 2.23043 8.4966 2.7242C9.27637 3.21797 9.89222 3.93188 10.2663 4.77564C10.6403 5.61941 10.7558 6.55515 10.598 7.46453C10.4403 8.37391 10.0164 9.21608 9.38 9.88457Z"
                                                                      fill="#009BEB"/>
                                                            </svg>
                                                            <span>відділення</span>
                                                        </a>
                                                    </div>

                                                    <div class="result__proposition_icon nomobile">
                                                      <div class="proposition-icon-box" @click="selectClientProposition($event, offer)">
                                                            <svg width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <g clip-path="url(#clip0_2_866)">
                                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M4.26042 3.64026L8.27083 9.66026V9.80026C8.27083 10.6403 8.05208 11.6903 7.46875 12.5303C6.8125 13.4403 5.79167 14.0003 4.26042 14.0003C2.72917 14.0003 1.70833 13.4403 1.05208 12.5303C0.46875 11.6903 0.25 10.6403 0.25 9.80026V9.59026L4.26042 3.64026ZM1.78125 10.5003C1.85417 10.9203 2 11.4103 2.29167 11.7603C2.58333 12.1803 3.23958 12.6003 4.26042 12.6003C5.28125 12.6003 5.9375 12.1803 6.22917 11.7603C6.44792 11.4103 6.66667 10.9903 6.73958 10.5003H1.78125ZM6.22917 9.10026H2.29167L4.26042 6.16026L6.22917 9.10026Z" fill="#009BEB"/>
                                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M13.7394 3.64026L17.7498 9.66026V9.80026C17.7498 10.6403 17.5311 11.6903 16.9478 12.5303C16.2915 13.4403 15.2707 14.0003 13.7394 14.0003C12.2082 14.0003 11.1873 13.4403 10.5311 12.5303C9.94775 11.6903 9.729 10.6403 9.729 9.80026V9.59026L13.7394 3.64026ZM11.2603 10.5003C11.3332 10.9203 11.479 11.4103 11.7707 11.7603C12.1353 12.2503 12.7186 12.6003 13.7394 12.6003C14.7603 12.6003 15.4165 12.1803 15.7082 11.7603C15.9269 11.4103 16.1457 10.9903 16.2186 10.5003H11.2603ZM15.7082 9.10026H11.8436L13.8123 6.16026L15.7082 9.10026Z" fill="#009BEB"/>
                                                                    <path d="M9 0C9.51042 0 10.0208 0.28 10.2396 0.7H15.5625V2.1H10.2396C10.0208 2.52 9.51042 2.8 9 2.8C8.48958 2.8 7.97917 2.52 7.76042 2.1H2.4375V0.7H7.76042C7.97917 0.28 8.48958 0 9 0Z" fill="#009BEB"/>
                                                                </g>
                                                                <defs>
                                                                    <clipPath id="clip0_2_866">
                                                                        <rect width="17.5" height="14" fill="white" transform="translate(0.25)"/>
                                                                    </clipPath>
                                                                </defs>
                                                            </svg>
                                                            <span v-if="clientPropositionsList.includes(offer)" class="span-checked">
                                                                <svg width="15" height="15" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <circle cx="9" cy="9" r="8" fill="#00B52C" stroke="white" stroke-width="2" />
                                                                    <path d="M5 8L8 11L13 6" stroke="white" stroke-width="2" />
                                                                </svg>
                                                            </span>
                                                    </div>
                                                      <div class="proposition-icon-box" v-if="!offer.discountPrice && !isApiUser"  @click="discountSet($event, offer)">
                                                        <svg width="18" height="18" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                                          <rect width="100" height="100" fill="url(#pattern0_927_2)"/>
                                                          <defs>
                                                            <pattern id="pattern0_927_2" patternContentUnits="objectBoundingBox" width="1" height="1">
                                                              <use xlink:href="#image0_927_2" transform="scale(0.01)"/>
                                                            </pattern>
                                                            <image id="image0_927_2" width="100" height="100" preserveAspectRatio="none" xlink:href="data:image/png;base64,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"/>
                                                          </defs>
                                                        </svg>
                                                        <modal-discount-set :id="offer.offerId" :offer="offer"  @update:offer="handleUpdateOffer"/>
                                                      </div>
                                                  </div>
                                                </div>
                                            </div>

                                            <div class="result__details">
                                                <div class="result__params">
                                                    <div class="result__param param-options">
                                                        <div class="heading">
                                                            <span>{{ showOptionCount(offer) }}</span>
                                                            опціі
                                                        </div>
                                                        <div class="descr">
                                                            Включено
                                                        </div>
                                                    </div>
                                                    <div class="result__param param-options">
                                                        <div class="heading">
                                                            <span>{{ showFranchise(offer) }}<span> грн</span></span> <i
                                                            data-placement="bottom"
                                                            data-toggle="tooltip"
                                                            title=""
                                                            class="icon question"
                                                            data-original-title="Сума до якої винуватець ДТП оплачує потерпілій стороні самостійно."></i>
                                                        </div>
                                                        <div class="descr">
                                                            Франшиза
                                                        </div>
                                                    </div>
                                                    <div class="result__param param-options"
                                                         v-if="offer.programmName && offer.programmName != ''">
                                                        <div class="heading">
                                                            <span>{{ offer.programmName }}</span> <i
                                                            data-placement="bottom"
                                                            data-toggle="tooltip"
                                                            title=""
                                                            class="icon question"
                                                            data-original-title="Деякі страхові компанії мають дві або більше пропозицій з однаковими франшизами, вони відрізняються вартістю поліса та комісійною винагородою, чим вища вартість, тим вища комісійна винагорода."></i>
                                                        </div>
                                                        <div class="descr">
                                                            <br>
                                                        </div>
                                                    </div>
                                                  <div class="result__param param-options"
                                                       v-if="offer.insurancesOsagoParameterGroup && offer.insurancesOsagoParameterGroup.length > 0"
                                                       @wheel="handleWheel(offer, $event)"
                                                  >
                                                    <div class="slider-container">
                                                      <div class="slider-content">
                                                        <div class="heading">
                                                          <span>{{ capitalizeFirstLetter(currentParam(offer)) }}</span>
                                                          <i data-placement="bottom"
                                                             data-toggle="tooltip"
                                                             title=""
                                                             class="icon question"
                                                             data-original-title="Ціна вказана з урахуванням додаткового параметру."></i>
                                                        </div>
                                                        <div v-if="offer.insurancesOsagoParameterGroup.length > 1" class="descr">
                                                          Додатковий параметр*
                                                        </div>
                                                        <div v-else class="descr">
                                                          Додатковий параметр
                                                        </div>
                                                      </div>
                                                        <div
                                                          v-if="offer.insurancesOsagoParameterGroup.length > 1"
                                                          class="arrow-container"
                                                          @click="next(offer)"
                                                        >
                                                          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" width="100" height="100">
                                                              <polygon points="34.0,7.090000152587891 34.0,91.91000366210938 78.43000030517578,49.5" fill="#FFA500"/>
                                                          </svg>
                                                      </div>
                                                    </div>

                                                  </div>
                                                    <div class="result__param param-price">
                                                        <div class="heading">
                                                            <div v-if="offer.dynamicDiscountedSum > 0 || offer.discountPrice > 0" class="old"
                                                                 data-placement="bottom" data-toggle="tooltip"
                                                                 title="Знижка надається безпосередньо за наш рахунок від ціни, що надається страховою компанією. Ми забезпечуємо найнижчу ціну на ринку. Вартість поліса вказана з урахуванням знижки.">
                                                                <span>{{ offer.price }} <span>грн</span></span>
                                                                <b v-if="offer.dynamicDiscountedSum > 0">-{{ offer.dynamicDiscountedSum }} грн</b>
                                                                <b v-else >-{{ offer.discountPercent }}%</b>
                                                            </div>
                                                            <div v-if="offer.dynamicDiscountPrice > 0 || offer.discountPrice > 0"
                                                                 :class="['value','red']">
                                                                <span>{{ offer.dynamicDiscountPrice || offer.discountPrice }}</span> грн
                                                            </div>
                                                            <div v-else :class="['value']">
                                                                <span>{{ offer.price }}</span> грн
                                                            </div>
                                                        </div>
                                                        <div class="descr">
                                                            Ціна
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="result__options__wrapp">
                                                    <div class="result__options">
                                                        <div v-if="!dataIdentificationCode && isEia(offer)" class="form-group__descr">
                                                          Платіж може бути перерахований після внесення ІПН страхувальника
                                                        </div>
                                                        <div class="heading">Рекомендуємо включити:</div>
                                                        <div class="result__options__list">
                                                            <div v-if="offer.listDgo && offer.listDgo.length !== 0"
                                                                 :class="['result__option', 'green', {'green-active': selectedDgo[offer.offerId]}]"
                                                                 onclick="$(this).closest('.result-item').find('.details-article-more__nav a:nth-child(2)').click();"
                                                                 @click="scrollTo(`#brandMore-${index}`)"
                                                                 data-toggle="collapse"
                                                                 :data-target="`#brandMore-${index}`"
                                                                 aria-expanded="false"
                                                                 :aria-controls="`#brandMore-${index}`">
                                                                <div class="icon">
                                                                </div>
                                                                <p>Дод. покриття</p>
                                                            </div>
                                                            <div v-else class="result__option green soon">
                                                                <div class="icon">
                                                                </div>
                                                                <p>Дод. покриття</p>
                                                            </div>
                                                            <div v-if="offer.listAutolawyer && offer.listAutolawyer.length !== 0" :class="['result__option', 'pink', 'autolawyer', {'pink-active': selectedAutolawyer[offer.offerId]}]" onclick="$(this).closest('.result-item').find('.details-article-more__nav a:nth-child(2)').click();" @click="scrollTo(`#brandMore-${index}`)" data-toggle="collapse" :data-target="`#brandMore-${index}`" aria-expanded="false" :aria-controls="`#brandMore-${index}`">
                                                                <div class="icon">
                                                                </div>
                                                                <p>Автоюрист</p>
                                                            </div>
                                                            <div v-else class="result__option pink soon">
                                                                <div class="icon">
                                                                </div>
                                                                <p>Мед. страховка</p>
                                                                <span class="label">Скоро</span>
                                                            </div>
                                                            <div class="result__option red soon">
                                                                <div class="icon">
                                                                </div>
                                                                <p>Міні КАСКО</p>
                                                                <span class="label">Скоро</span>
                                                            </div>
                                                            <div class="result__option violet soon">
                                                                <div class="icon">
                                                                </div>
                                                                <p>Прям. врегулюв.</p>
                                                                <span class="label">Скоро</span>
                                                            </div>
                                                            <button class="params__more soon">
                                                                Ще
                                                                <span class="label">Скоро</span>
                                                            </button>
                                                        </div>
                                                        <div class="result__options__active">
                                                            <div v-if="offer.costAddedDgo" class="active-item">
                                                                <span class="default">Дод. покриття</span>
                                                                <span class="mob">Додаткове покриття</span>
                                                                <span v-if="offer.listDgo != null"
                                                                      v-for="(dgo) in offer.listDgo">
                                                                    <span v-if="parseFloat(dgo.cost) == offer.costAddedDgo && parseFloat(dgo.coverage) == parseFloat(offer.dgoCoverage)">
                                                                        + {{ dgo.coverage | toNumerals }} грн (за
                                                                        {{ dgo.cost | toNumerals }} грн)
                                                                    </span>
                                                                </span>


                                                                    <button v-if="!((offer.ex_id == 1011 /*|| offer.ex_id == 1008*/) && offer.customerType == 3)" @click="deleteDgo(offer)">
                                                                        <svg width="10" height="10" viewBox="0 0 10 10"
                                                                             fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                            <path d="M9 1L1 9" stroke="#499797"/>
                                                                            <path d="M1 1L9 9" stroke="#499797"/>
                                                                        </svg>
                                                                    </button>
                                                            </div>

                                                            <div v-if="offer.costAddedAutolawyer" class="active-item pink">
                                                                <span class="default">Договір Автоюрист</span>
                                                                <span class="mob">Договір Автоюрист</span>
                                                                <span v-if="offer.listAutolawyer != null"  v-for="(autolawyer) in offer.listAutolawyer">
                                                                    <span v-if="parseInt(autolawyer.price) == offer.costAddedAutolawyer">
                                                                         "{{ autolawyer | toAutolawyerName}}" (за {{ autolawyer.price | toNumerals }} грн)
                                                                    </span>
                                                                </span>
                                                                <button @click="deleteAutolawyer(offer)">
                                                                    <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                        <path d="M9 1L1 9" stroke="#499797" />
                                                                        <path d="M1 1L9 9" stroke="#499797" />
                                                                    </svg>
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="result__more">
                                                    <a @click="scrollTo(`#brandMore-${index}`)" data-toggle="collapse"
                                                       :data-target="`#brandMore-${index}`" aria-expanded="false"
                                                       :aria-controls="`brandMore-${index}`" class="collapsed">
                                                        Детальніше про поліс
                                                        <img src="../../public/images/insurance/issue/arrow-down.svg"
                                                             alt="Подробнее о полисе">
                                                    </a>
                                                </div>
                                            </div>
                                            <div class="result__order">
                                                <div v-if="showEarnings && (offer.dynamicEarnings || offer.earnings)">
                                                    <div class="result__earnings" >
                                                        Нетто-платіж {{ showNetto(offer) | toFixed}} грн
                                                    </div>
                                                </div>
                                                <div class="result__price">
                                                    <div v-if="offer.dynamicDiscountedSum > 0 || offer.discountPrice > 0" class="old"
                                                         data-placement="bottom" data-toggle="tooltip"
                                                         title="Знижка надається безпосередньо за наш рахунок від ціни, що надається страховою компанією. Ми забезпечуємо найнижчу ціну на ринку. Вартість поліса вказана з урахуванням знижки.">
                                                        <span>{{ showPrice(offer) }} <span>грн</span></span>
                                                        <b v-if="offer.dynamicDiscountedSum > 0">-{{ offer.dynamicDiscountedSum }} грн</b>
                                                        <b v-else >-{{ offer.discountPercent }}%</b>
                                                    </div>
                                                    <div v-if="offer.dynamicDiscountPrice > 0 || offer.discountPrice > 0" :class="['value','red']">
                                                      {{ showDiscountPrice(offer) }} <span>грн</span>
                                                    </div>
                                                    <div v-else :class="['value']">
                                                       {{ showPrice(offer) }} <span>грн</span>
                                                    </div>
                                                </div>

                                                <button v-if="user.recipientTypeId != 4" class="result__submit" v-loading="concludeOffer"
                                                        v-on:click="concludeСontract(offer)">
                                                    Оформити
                                                </button>
                                                <button v-else-if="user.recipientTypeId == 4 && clientPropositionsList.includes(offer)" class="btn prop-button btn-outline-blue" v-loading="concludeOffer"
                                                        v-on:click="selectClientProposition($event, offer)">
                                                    Обрано
                                                </button>
                                                <button v-else-if="user.recipientTypeId == 4 && !clientPropositionsList.includes(offer)" class="btn prop-button btn-orange" v-loading="concludeOffer"
                                                        v-on:click="selectClientProposition($event, offer)">
                                                    Обрати
                                                </button>
                                                <div class="result__earnings" v-if="showEarnings && (offer.dynamicEarnings || offer.earnings)">
                                                    Ваш заробіток {{ showEarning(offer) | toFixed(2) }} грн
                                                </div>
                                                <div class="result__earnings" v-if="showEarnings && (offer.dynamicEarnings || offer.earnings)">
                                                    ({{ offer | toPercentageOfEarnings  }}%)
                                                </div>
                                                <div class="result__earnings" v-if="showEarnings && (offer.dynamicEarnings || offer.earnings) && !isApiUser">
                                                Мін. ціна для продажу: {{ showMinPrice(offer) }} грн
                                              </div>
                                            </div>

                                            <div class="result__nav mob">
                                                <a @click="scrollTo(`#brandMore-${index}`)" class="more collapsed"
                                                   data-toggle="collapse" :data-target="`#brandMore-${index}`"
                                                   aria-expanded="false"
                                                   :aria-controls="`brandMore-${index}`">
                                                    Детальніше
                                                    <img src="../../public/images/insurance/issue/arrow-down.svg"
                                                         alt="Детальніше">
                                                </a>
                                                <div class="result__proposition_icon mobile">
                                                    <div class="proposition-icon-box"  @click="selectClientProposition($event, offer)">
                                                        <svg class="vesu" width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <g clip-path="url(#clip0_2_866)">
                                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M4.26042 3.64026L8.27083 9.66026V9.80026C8.27083 10.6403 8.05208 11.6903 7.46875 12.5303C6.8125 13.4403 5.79167 14.0003 4.26042 14.0003C2.72917 14.0003 1.70833 13.4403 1.05208 12.5303C0.46875 11.6903 0.25 10.6403 0.25 9.80026V9.59026L4.26042 3.64026ZM1.78125 10.5003C1.85417 10.9203 2 11.4103 2.29167 11.7603C2.58333 12.1803 3.23958 12.6003 4.26042 12.6003C5.28125 12.6003 5.9375 12.1803 6.22917 11.7603C6.44792 11.4103 6.66667 10.9903 6.73958 10.5003H1.78125ZM6.22917 9.10026H2.29167L4.26042 6.16026L6.22917 9.10026Z" fill="#009BEB"/>
                                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M13.7394 3.64026L17.7498 9.66026V9.80026C17.7498 10.6403 17.5311 11.6903 16.9478 12.5303C16.2915 13.4403 15.2707 14.0003 13.7394 14.0003C12.2082 14.0003 11.1873 13.4403 10.5311 12.5303C9.94775 11.6903 9.729 10.6403 9.729 9.80026V9.59026L13.7394 3.64026ZM11.2603 10.5003C11.3332 10.9203 11.479 11.4103 11.7707 11.7603C12.1353 12.2503 12.7186 12.6003 13.7394 12.6003C14.7603 12.6003 15.4165 12.1803 15.7082 11.7603C15.9269 11.4103 16.1457 10.9903 16.2186 10.5003H11.2603ZM15.7082 9.10026H11.8436L13.8123 6.16026L15.7082 9.10026Z" fill="#009BEB"/>
                                                                <path d="M9 0C9.51042 0 10.0208 0.28 10.2396 0.7H15.5625V2.1H10.2396C10.0208 2.52 9.51042 2.8 9 2.8C8.48958 2.8 7.97917 2.52 7.76042 2.1H2.4375V0.7H7.76042C7.97917 0.28 8.48958 0 9 0Z" fill="#009BEB"/>
                                                            </g>
                                                            <defs>
                                                                <clipPath id="clip0_2_866">
                                                                    <rect width="17.5" height="14" fill="white" transform="translate(0.25)"/>
                                                                </clipPath>
                                                            </defs>
                                                        </svg>
                                                        <span v-if="clientPropositionsList.includes(offer)" class="span-checked">
                                                                <svg width="15" height="15" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <circle cx="9" cy="9" r="8" fill="#00B52C" stroke="white" stroke-width="2" />
                                                                    <path d="M5 8L8 11L13 6" stroke="white" stroke-width="2" />
                                                                </svg>
                                                            </span>
                                                    </div>
                                                    <div class="proposition-icon-box" v-if="!offer.discountPrice && !isApiUser" @click="discountSet($event, offer)">
                                                      <svg width="26" height="26" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                                        <rect width="100" height="100" fill="url(#pattern0_927_3)"/>
                                                        <defs>
                                                          <pattern id="pattern0_927_3" patternContentUnits="objectBoundingBox" width="1" height="1">
                                                            <use xlink:href="#image0_927_3" transform="scale(0.01)"/>
                                                          </pattern>
                                                          <image id="image0_927_3" width="100" height="100" preserveAspectRatio="none" xlink:href="data:image/png;base64,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"/>
                                                        </defs>
                                                      </svg>

                                                      <modal-discount-set :id="offer.offerId" v-model="offer.showModal" :offer="offer"  @update:offer="handleUpdateOffer"/>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="row details collapse details-article-more"
                                             :id="`brandMore-${index}`">
                                            <div class="col-12">
                                                <div class="details__wrapp">
                                                    <div class="dropdown details-article-more__nav">
                                                        <button
                                                            class="dropdown-toggle details-article-more__placeholder collapsed"
                                                            :id="`dropdownDetails-${index}`"
                                                            data-toggle="dropdown" data-flip="false">
                                                            Загальна інформація
                                                        </button>
                                                        <div class="nav dropdown-menu" role="tablist" data-tabs="tabs"
                                                             aria-labelledby="`dropdownDetails-${index}`">
                                                            <a :href="`#resultMore-Tab1-${index}`" data-toggle="tab"
                                                               class="active"
                                                               onclick="$(this).closest('.result-item').find('.details-article-more__placeholder').text($(this).text())">Загальна
                                                                інформація</a>
                                                            <a v-if="(offer.listDgo && offer.listDgo.length !== 0 ) || (offer.listAutolawyer && offer.listAutolawyer.length !== 0)"
                                                               :href="`#resultMore-Tab2-${index}`" data-toggle="tab"
                                                               onclick="$(this).closest('.result-item').find('.details-article-more__placeholder').text($(this).text())">Додаткові
                                                                опції</a>
                                                        </div>
                                                    </div>

                                                    <div class="details-article-more__content tab-content">
                                                        <div
                                                            class="details-article-more__container tab-pane fade in active show"
                                                            :id="`resultMore-Tab1-${index}`"
                                                            role="tabpanel">
                                                            <div class="details__first-tab">
                                                                <div class="details__params">
                                                                    <div class="details__params__list">
                                                                        <p class="company_links">
<!--                                                                          <span v-if="offer.company.companyLink">-->
<!--                                                                              <a target="_blank" :href="offer.company.companyLink">Автоцивілка (ОСЦПВ)</a>-->
<!--                                                                          </span>-->
<!--                                                                          <span v-if="offer.company.companyDgoLink">-->
<!--                                                                              <a target="_blank" :href="offer.company.companyDgoLink">ДЦВ Online</a>-->
<!--                                                                          </span>-->
                                                                          <span v-if="offer.company.docProduct">
                                                                                <a target="_blank" :href="offer.company.docProduct">Інформація про страховий продукт</a>
                                                                          </span>
                                                                          <span v-if="offer.company.docCompany">
                                                                              <a target="_blank" :href="offer.company.docCompany">Інформація про cтрахову компанію</a>
                                                                          </span>
                                                                          <span v-if="offer.company.docAgent">
                                                                              <a target="_blank" :href="offer.company.docAgent">Інформація про страхового посередника</a>
                                                                          </span>
                                                                          <span v-if="offer.company.docZusp">
                                                                              <a target="_blank" :href="offer.company.docZusp">Інформація про загальні умови страхового продукту</a>
                                                                          </span>
                                                                          <span v-if="offer.costAddedDgo && offer.dgoCompanyInfo && offer.dgoCompanyInfo.company_info.doc_product">
                                                                              <a target="_blank" :href="offer.dgoCompanyInfo.company_info.doc_product">Інформація про страховий продукт ДЦВ</a>
                                                                          </span>
                                                                          <span v-if="offer.costAddedDgo && offer.dgoCompanyInfo && offer.dgoCompanyInfo.company_info.doc_zusp">
                                                                              <a target="_blank" :href="offer.dgoCompanyInfo.company_info.doc_zusp">Інформація про загальні умови страхового продукту ДЦВ</a>
                                                                          </span>
                                                                          <span v-if="offer.costAddedDgo && offer.dgoCompanyInfo && !offer.hasOwnDgo && offer.dgoCompanyInfo.company_info.doc_company">
                                                                              <a target="_blank" :href="offer.dgoCompanyInfo.company_info.doc_company">Інформація про cтрахову компанію ДЦВ</a>
                                                                          </span>
                                                                          <span v-if="offer.costAddedDgo && offer.dgoCompanyInfo && !offer.hasOwnDgo && offer.dgoCompanyInfo.company_info.doc_agent">
                                                                              <a target="_blank" :href="offer.dgoCompanyInfo.company_info.doc_agent">Інформація про страхового посередника ДЦВ</a>
                                                                          </span>

                                                                        </p>
                                                                        <ProductDescription class="mb-3" :description="offer.company.description" />
                                                                        <p>Базові опції</p>
                                                                        <ul>
                                                                            <li>Покриття відповідальності по майну до
                                                                                250 000 грн
                                                                                <i
                                                                                    data-placement="top"
                                                                                    data-toggle="tooltip"
                                                                                    title=""
                                                                                    class="icon question"
                                                                                    data-original-title="Максимальна сума, яку покриє страхова за шкоду, заподіяну майну потерпілих з вини застрахованого винуватця ДТП. Якщо сума вище зазначеної, різниця покривається винуватцем ДТП."></i>
                                                                            </li>
                                                                            <li>Покриття відповідальності за здоров'ям
                                                                                до 500 000 грн
                                                                                <i
                                                                                    data-placement="top"
                                                                                    data-toggle="tooltip"
                                                                                    title=""
                                                                                    class="icon question"
                                                                                    data-original-title="Максимальна сума, яку покриє страхова, за завдану шкоду здоров'ю потерпілих з вини застрахованого винуватця ДТП. Якщо сума вище зазначеної, різниця покривається винуватцем ДТП."></i>
                                                                            </li>
                                                                        </ul>
                                                                    </div>
                                                                    <div class="details__params__list">
                                                                        <p>Додатково від страхової</p>
                                                                        <ul>
                                                                            <li v-bind:class="{ active: offer.company.directSettlement, disabled: !offer.company.directSettlement }">
                                                                                Пряме врегулювання
                                                                            </li>
                                                                            <li v-bind:class="{ active: offer.company.supportEverytime, disabled: !offer.company.supportEverytime }">
                                                                                Допомога 24/7
                                                                            </li>
                                                                            <li v-bind:class="{ active: offer.company.medicineHelp, disabled: !offer.company.medicineHelp }">
                                                                                Медична допомога
                                                                            </li>
                                                                            <li class="custom-option"
                                                                                v-for="option in offer.company.customOptions">
                                                                                <span v-if="option"
                                                                                      class="active">{{ option }}</span>
                                                                            </li>
                                                                        </ul>
                                                                    </div>
                                                                </div>
                                                                <div class="mtsbu-rating"
                                                                     v-if="offer.company.mtsbuRating != null">
                                                                    <div class="mtsbu-rating__heading">
                                                                        <span>Рейтинг</span>
                                                                        <img src="../../public/images/mtsbu-logo.png"
                                                                             alt="МТСБУ">
                                                                        <i class="icon question" data-placement="bottom"
                                                                           data-toggle="tooltip"
                                                                           title="На основі квартального звіту МТСБУ по ОСЦПВ"></i>
                                                                        <p>На основі квартального звіту МТСБУ по
                                                                            ОСЦПВ</p>
                                                                    </div>
                                                                    <ul class="mtsbu-rating__list">
                                                                        <li class="mtsbu-rating__item">
                                                                    <span
                                                                        class="mtsbu-rating__name">Загальна оцінка</span>
                                                                            <span
                                                                                class="mtsbu-rating__value rating-good"
                                                                                v-if="offer.company.mtsbuRating.paramAssessment > 4">
                                                                    <span>Добре</span>
                                                                </span>
                                                                            <span
                                                                                class="mtsbu-rating__value rating-medium"
                                                                                v-if="offer.company.mtsbuRating.paramAssessment > 3 && offer.company.mtsbuRating.paramAssessment < 5">
                                                                    <span>Середньо</span>
                                                                </span>
                                                                            <span class="mtsbu-rating__value rating-bad"
                                                                                  v-if="offer.company.mtsbuRating.paramAssessment < 3">
                                                                    <span>Погано</span>
                                                                </span>
                                                                        </li>
                                                                        <li class="mtsbu-rating__item">
                                                                    <span
                                                                        class="mtsbu-rating__name">Качество урегулирования</span>
                                                                            <span
                                                                                class="mtsbu-rating__value rating-good"
                                                                                v-if="offer.company.mtsbuRating.paramQuality > 4">
                                                                    <span>Добре</span>
                                                                </span>
                                                                            <span
                                                                                class="mtsbu-rating__value rating-medium"
                                                                                v-if="offer.company.mtsbuRating.paramQuality > 2 && offer.company.mtsbuRating.paramQuality < 5">
                                                                    <span>Середньо</span>
                                                                </span>
                                                                            <span class="mtsbu-rating__value rating-bad"
                                                                                  v-if="offer.company.mtsbuRating.paramQuality < 3">
                                                                    <span>Погано</span>
                                                                </span>
                                                                        </li>
                                                                        <li class="mtsbu-rating__item">
                                                                    <span
                                                                        class="mtsbu-rating__name">Уровень жалоб</span>
                                                                            <span
                                                                                class="mtsbu-rating__value rating-good"
                                                                                v-if="offer.company.mtsbuRating.paramClaims > 4">
                                                                    <span>Добре</span>
                                                                </span>
                                                                            <span
                                                                                class="mtsbu-rating__value rating-medium"
                                                                                v-if="offer.company.mtsbuRating.paramClaims >= 3 && offer.company.mtsbuRating.paramClaims < 5">
                                                                    <span>Середньо</span>
                                                                </span>
                                                                            <span class="mtsbu-rating__value rating-bad"
                                                                                  v-if="offer.company.mtsbuRating.paramClaims < 3">
                                                                    <span>Погано</span>
                                                                </span>
                                                                        </li>
                                                                    </ul>
                                                                    <div class="mtsbu-rating__deadlines">
                                                                        <span>{{
                                                                                offer.company.compensationDays
                                                                            }} днів</span>
                                                                        <p>швидкість виплати по ОСЦПВ</p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div v-if="(offer.listDgo && offer.listDgo.length !== 0 ) || (offer.listAutolawyer && offer.listAutolawyer.length !== 0)"
                                                             class="details-article-more__container tab-pane fade"
                                                             :id="`resultMore-Tab2-${index}`" role="tabpanel">
                                                            <div class="details-dop-products">
                                                                <div v-if ="offer.listDgo && offer.listDgo.length !== 0" class="details-article__options">
                                                                    <div class="details-article__option green">
                                                                        <div class="wrapp">
                                                                            <div class="content" style="padding: 0 !important;">
                                                                                <div
                                                                                    class="heading">Дод. покриття
                                                                            </div>
                                                                                <div
                                                                                    class="descr">Рекомендуємо розширити
                                                                                ліміти страхового покриття, особливо для
                                                                                жителів великих міст
                                                                            </div>
                                                                            </div>
                                                                            <div class="icon">
                                                                            </div>
                                                                        </div>

                                                                        <div class="select-wrapp">
                                                                            <select v-model="selectedDgo[offer.offerId]"
                                                                                @click.prevent="closeHint"
                                                                                @change="selectDgo($event, offer)"
                                                                                class="custom-select"
                                                                                :id="`selectDgo${offer.offerId}`">
                                                                                <option v-if="!((offer.ex_id == 1011 /*|| offer.ex_id == 1008*/) && offer.customerType == 3)"  :earning="0" :value="undefined"
                                                                                    selected>Додаткове покриття
                                                                                </option>
                                                                                <option
                                                                                :earning="dgo.earning"
                                                                                :value="{cost: dgo.cost, earning: dgo.earning }"
                                                                                :id-dgo="dgo.id"
                                                                                :dgo-price="dgo.cost"
                                                                                :coverage="dgo.coverage"
                                                                                :company_id="dgo.company_id"
                                                                                v-for="(dgo) in offer.listDgo">+
                                                                                {{ dgo.coverage | toNumerals }} грн (за
                                                                                {{ dgo.cost | toNumerals }} грн)
                                                                            </option>
                                                                            </select>
                                                                        </div>
                                                                    </div>
                                                                </div>


                                                                <div v-if="offer.listAutolawyer && offer.listAutolawyer.length !== 0" class="details-article__options">
                                                                    <div class="details-article__option pink">
                                                                        <div class="wrapp">
                                                                            <div class="content" style="padding: 0 !important">
                                                                                <div
                                                                                    class="heading">Автоюрист</div>
                                                                                <div
                                                                                    class="descr">Рекомендуємо скористатися послугами автоюриста, щоб мати захист у разі ДТП або спірних ситуацій на дорозі.</div>
                                                                            </div>
                                                                            <div class="icon">
                                                                            </div>
                                                                        </div>
                                                                        <div class="select-wrapp">
                                                                            <select v-model="selectedAutolawyer[offer.offerId]"
                                                                                    @click.prevent="closeHint"
                                                                                    @change="selectAutolawyer($event, offer)"
                                                                                    class="custom-select"
                                                                                    :id="`selectAutolawyer${offer.offerId}`">
                                                                                <option :earning="0" :value="undefined"  selected>Пакет послуг</option>
                                                                                <option
                                                                                    :earning="autolawyer.earning"
                                                                                    :value="{price: autolawyer.price, earning: autolawyer.earning }"
                                                                                    :id-autolawyer="autolawyer.id"
                                                                                    :autolawyer-price="autolawyer.price"
                                                                                    :offerId-autolawyer="autolawyer.offerId"
                                                                                    :program-autolawyer="autolawyer.program"
                                                                                    :company_id="autolawyer.companyId"
                                                                                    v-for="(autolawyer) in offer.listAutolawyer">+ "{{ autolawyer | toAutolawyerName}}" (за {{ autolawyer.price | toNumerals }} грн)</option>
                                                                            </select>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>


                                                        </div>


                                                        <div v-if="offer.listAutolawyer && offer.listAutolawyer.length !== 0"
                                                             class="details-article-more__container tab-pane fade"
                                                             :id="`resultMore-Tab2-${index}`" role="tabpanel">
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <!---->
                                </div>
                            </div>


                            <div class="col-12 text-center">
                                <button @click="scrollTop" class="result-list__scrolltop">
                                    <span>Вгору</span></button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
          <modalCompanyBranches ref="modalCompanyBranches"></modalCompanyBranches>
        </div>
    </div>
</template>


<script>
import displaySettings from '../mixin/displaySettings';
import { getList as getCompanyBranchesList } from '@/api/companyBranches';
import { saveOrder } from '@/api/order';
import ModalDiscountSet from '@/components/app/modals/modal-discount-set.vue';
import ModalReplenishment from '@/components/app/modals/modal-replenishment.vue';
import { CompanyBranches as modalCompanyBranches } from '@/components/app/modals/order';
import ClientPropositionInfo from '@/components/app/osago/ClientPropositionInfo.vue';
import OsagoPolicy from '@/components/app/osago/OsagoPolicy.vue';
import userSettings from '@/mixin/userSettings';
import OsagoSearchForm from '@/views/calculatorOsago/components/OsagoSearchForm.vue';
import { discountMixin } from '@/mixin/discountMixin';
import { ProductDescription } from '@/shared/ui/insurance';

//TODO (Denis) вот тут добавить бы логику, если например заппрос не сработал или не дал результатов, то появилосб окошко с собщение
// типо попробуйте ввести другие данные или выберите другую франшизу или что то такое.
//  Кнопка, вернутся в верх списка, должна быть наверное только когда страховых много или на экран не помещаются
// возможно это будет сложно сделать.
// Мне кажется тут нужно так же добавить фильтр по франшизам, где можно будет выбирать и прогружать все франшизы
// Но есть нюанс, если уже сделали запрос на франшизу, а потом убрали её с фильтра и назад добавили, то не долже идти новый запрос
export default {
  components: {
    ModalReplenishment,
    OsagoPolicy, modalCompanyBranches, OsagoSearchForm, ClientPropositionInfo, ModalDiscountSet, ProductDescription },
  data: function () {
    return {
      currentIndexes: {},
      modalPosition: { top: '0px', left: '0px' },
      concludeOffer: false,
      dataCarType: null,
      monthList: null,
      dataCarTypeOption: null,
      dataCarNumber: null,
      dataCustomerPrivilege: null,
      dataCarTypeGroup: null,
      dataStartOrder: moment(new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() + 1)).format('DD.MM.YYYY'),
      dataOtk: null,
      withoutOtk: false,
      dataCustomerTypeId: null,
      dataTaxi: 0,
      dataEuro: 0,
      dataIdentificationCode: "",
      dataRegistrationPlaceId: null,
      dataCarbirthdayAt: null,
      dataCarAdditionalParameters: null,
      dataCarKilometers: null,
      dataCarYear: null,
      dataCarBrand: null,
      dataCarVin: null,
      dataCarAge: null,
      dataCarBirthDateOwner: null,
      dataCarModel: null,
      dataZone: null,
      registrationType: null,
      selectedDgo: [],
      selectedAutolawyer: [],
      showEarnings: false,
      companyId: null,
      activeClassCompany: '',
      activeClassWrapp: '',
      focusedPriceDiapason: false,
      clientPropositionsList: [],
      clientProposition: null,
      showPropositionModal: false,
      filters: {
        sort: 'price-earnings',
        type: 'all',
        company: [],
        priceDiapason: { min: '', max: '' },
        franchises: [],
        franchise: null,
        franchiseList: [0, 1000, 1300, 1500, 1600, 2000, 2400, 2500, 2600, 3000, 3200],
        optionsList: [],
        directSettlement: false,
        supportEverytime: false,
        medicineHelp: false,
        customOptions: [],
        monthList: [],
      },
      watchDefaultOffersSortType: null,
      orderId: null,
      userData: {
        name: '',
        phone: '0',
        email: '',
        surname: '',
        dateBirth: '',
        patronymic: '',
        identificationCode: '',
        withoutIdentificationCode: false,
        erdpyCode: null,
        documentation: {
          //TODO текущее значение нобходимо будет брать с словаря(api)
          type: 1,//'DOCUMENT_PASSPORT'
          serial: '',
          number: '',
          issuedBy: '',
          dateOfIssue: '',
          endDateOfIssue: '',
          dateOfIssueError: false,
        },
        address: {
          street: ' ',
          house: '',
          number: '',
          cityId: 1
        }
      },
      offers: false,
    };
  },

  computed: {
    user() {
      return this.$store.getters.USER;
    },
    isApiUser() {
      return this.user && Number(this.user.type_id) === 5;
    },
    osagoSearchParams() {
      return this.$store.state.osagoStore.requestData;
    },
    osagoDateInfo() {
      return this.$store.state.osagoStore.dateInfo;
    },
    loadingOffers() {
      return this.$store.state.osagoStore.loadingOsagoOffers;
    },
    orderData() {
      return this.$store.state.osagoStore.infoOrder;
    },
    dateInfo() {
      return this.$store.state.osagoStore.dateInfo;
    },
    requestData() {
      return Object.assign({}, this.$route.query);
    },
    uniqueNames: function () {
      let removeDuplicateValue = [];
      if(this.$store.state.osagoStore.osagoOffers){
        for (let i = 0; i < this.$store.state.osagoStore.osagoOffers.length; i++) {
          if (removeDuplicateValue.indexOf(this.$store.state.osagoStore.osagoOffers[i].companyNamePublic) === -1) {
            removeDuplicateValue.push(this.$store.state.osagoStore.osagoOffers[i].companyNamePublic);
          }
        }
      }
      return removeDuplicateValue.sort();
    },
    customOptions: function () {
      let customOptions = [];
      let result = this.$store.state.osagoStore.osagoOffers;
      if(result){
        result.forEach((item) => {
          if (item.company.customOptions == null) {
            return;
          }
          item.company.customOptions.forEach((customOption) => {
            if (customOptions.indexOf(customOption) == -1) {
              if (customOption != null) {
                customOptions.push(customOption);
              }
            }
          });
        });
      }
      return customOptions.sort();
    },
  },
  /**
   *
   * @returns {*}
   */
  serverPrefetch() {
    return this.fetchOffers();
  },
  watch: {
    loadingOffers(newValue, oldValue) {
      if(oldValue && !newValue) {
        this.sortOffers();
      }
    },
    filters: {
      handler: function () {
        this.sortOffers();
      },
      deep: true
    }
  },
  created() {
    this.fillInCalculatorOptions();

    this.watchDefaultOffersSortType = this.$watch('defaultOffersSortType', function (value) {
      this.filters.sort = value;
      $('.nice-select').niceSelect('update');
      this.watchDefaultOffersSortType();
    });
  },

  /**
   *`
   */
  mounted() {
    this.fetchOffers();

    $('.nice-select').niceSelect();

    $('[data-toggle="tooltip"]').tooltip({
      html: true
    });
  },
  filters: {
    toPercent: function (item) {
      return Math.round((item.dynamicDiscountPrice || item.discountPrice) / ((item.dynamicDiscountPrice || item.discountPrice) + item.price) * 100);
    },
    toPercentageOfEarnings(item) {
      let earnings =  item.earnings;
      if(item.dynamicDiscountedSum > 0){
        earnings -= parseFloat(item.dynamicDiscountedSum);
      }

      let earningAutolawyer = (!!this?.selectedAutolawyer && this.selectedAutolawyer.length > 0) ? (this.selectedAutolawyer[item.offerId]?.earning || 0) : 0;
      let earningDgo = (!!this?.selectedDgo && this.selectedDgo.length > 0) ? (this.selectedDgo[item.offerId]?.earning || 0) : 0;

      return Math.round(((earnings + earningAutolawyer + earningDgo) / item.price) * 100);
    },
    toFixed: function (value, precision) {
      return value.toFixed(precision || 2);
    },
    toNumerals: function (value) {
      let newValue = parseFloat(value);
      if (isNaN(newValue)) {
        return value;
      }
      return newValue.toLocaleString();
    },
    toAutolawyerName: function (item) {
      switch (item.program) {
        case 2:
          return 'Комфорт';
        case 3:
          return 'Комфорт плюс';
        default:
          return 'Стандарт';
      }
    },
  },

  /**
   *
   */
  methods: {
    isEia(offer){
      return [1015].includes(parseInt(offer?.ex_id));
    },
    showNetto(offer){
      let earnings = this.showEarning(offer);
      let price = (offer.dynamicDiscountPrice > 0 || offer.discountPrice > 0) ? this.showDiscountPrice(offer) : this.showPrice(offer);
      return Number(price) - Number(earnings);
    },
    showEarning(offer){
      return Number((offer.dynamicDiscountPrice > 0) ? offer.dynamicEarnings : offer.earnings);
    },
    showPrice(offer){
      return Number(offer.price) ;
    },
    showDiscountPrice(offer){
      return Number(offer.dynamicDiscountPrice || offer.discountPrice || (offer.price - (offer.dynamicDiscountedSum || 0)));
    },
    handleUpdateOffer(updatedOffer) {
      this.offers.forEach((offer) => {
        this.$set(offer, 'showModal', false);
        if (offer.offerId === updatedOffer.offerId) {
          if (parseFloat(updatedOffer.price) > parseFloat(updatedOffer.discountPrice)) {
            const dynamicDiscountPrice = parseFloat(updatedOffer.discountPrice).toFixed(2);
            this.$set(offer, 'dynamicDiscountPrice', parseFloat(dynamicDiscountPrice));
            this.$set(offer, 'dynamicDiscountPercent', parseFloat(updatedOffer.discountPercent).toFixed(2));
            this.$set(offer, 'dynamicDiscountedSum', parseFloat(updatedOffer.discountedSum).toFixed(2));
            this.$set(offer, 'dynamicEarnings', parseFloat(updatedOffer.earnings).toFixed(2));
          } else if (parseFloat(updatedOffer.discountPrice) >= 0) {
            this.$set(offer, 'dynamicDiscountPrice', 0);
            this.$set(offer, 'dynamicDiscountPercent', 0);
            this.$set(offer, 'dynamicDiscountedSum', 0);
            this.$set(offer, 'dynamicEarnings', 0);
          }
        }
      });
    },
    handleWheel(offer, event) {
      event.preventDefault();
      const delta = Math.sign(event.deltaY);  // Положительное значение для прокрутки вниз, отрицательное для вверх
      if (delta > 0) {
        this.next(offer); // Прокрутка вниз, следующий элемент
      } else {
        this.prev(offer); // Прокрутка вверх, предыдущий элемент
      }
    },
    currentParam(offer) {
      const index = this.currentIndexes[offer.offerId] ?? 0;
      return offer.insurancesOsagoParameterGroup[index]?.description || '';
    },
    next(offer) {
      const currentIndex = this.currentIndexes[offer.offerId] ?? 0;
      const maxIndex = offer.insurancesOsagoParameterGroup.length - 1;
      this.$set(this.currentIndexes, offer.offerId, currentIndex < maxIndex ? currentIndex + 1 : 0);
    },
    prev(offer) {
      const currentIndex = this.currentIndexes[offer.offerId] ?? 0;
      const maxIndex = offer.insurancesOsagoParameterGroup.length - 1;
      this.$set(this.currentIndexes, offer.offerId, currentIndex > 0 ? currentIndex - 1 : maxIndex);
    },
    capitalizeFirstLetter(str) {
      if(!str) return '';
      return str.charAt(0).toUpperCase() + str.slice(1);
    },
    selectClientProposition(event, value) {
      const index = this.clientPropositionsList.indexOf(value);
      if (index === -1) {
        this.clientPropositionsList.push(value);
        this.showPropositionModal = true;
      } else {
        this.clientPropositionsList.splice(index, 1);
      }
    },
    discountSet(event, offer){
      this.$set(offer, 'showModal', !offer.showModal);
    },
    saveClientPropositions() {
      // console.log('event', event.target.checked)
    },
    removeClientProposition(value) {
      const index = this.clientPropositionsList.indexOf(value);
      if (index === -1) {
        this.clientPropositionsList.push(value);
      } else {
        this.clientPropositionsList.splice(index, 1);
      }
    },
    clearPropositions() {
      this.clientPropositionsList = [];
    },
    fillInCalculatorOptions() {
      const query = this.$route.query;
      let carTypeInfo = JSON.parse(decodeURIComponent(query.carTypeInfo));
      this.requestData.carTypeInfo = carTypeInfo;
      let carExperience = JSON.parse(decodeURIComponent(query.experience));
      this.requestData.experience = carExperience;
      let cityInfo = JSON.parse(decodeURIComponent(query.cityInfo));
      this.requestData.cityInfo = cityInfo;
      let car = JSON.parse(decodeURIComponent(query.car));
      this.requestData.car = car;

      this.dataCustomerTypeId = query.customerType;
      this.dataTaxi = query.isTaxi;
      this.dataEuro = query.isEuroCar;
      this.dataCustomerPrivilege = query.customerPrivilege;
      this.dataCarNumber = this.$store.state.osagoStore.carInfo.number;
      this.dataRegistrationPlaceId = query.registrationPlaceId;
      this.dataIdentificationCode = query.identificationCode;
      this.dataZone = query.zone;
      this.dataCarTypeGroup = carTypeInfo.group;
      this.dataCarType = carTypeInfo.external_id;
      this.dataCarTypeOption = query.autoCategoryType;
      this.registrationType = query.registrationType ? Number(query.registrationType) : undefined;
      this.dataStartOrder = query.startDate;
      this.dataOtk = query.otkDate;
      this.monthList = query.months;

      this.dataCarYear = car.year;
      this.dataCarModel = car.model;
      this.dataCarBrand = car.brand;
      this.dataCarVin = car.vin;
      this.dataCarAge = car.age;
      this.dataCarBirthDateOwner = car.birthDateOwner;
      this.dataCarKilometers = car.kilometers;
      this.dataCarbirthdayAt = car.birthdayAt;
      this.dataCarAdditionalParameters = car.additional_parameters;

      this.$store.commit('SET_CLIENT', null);
    },
    isCrossProduct(offer) {
      return offer?.otherData?.crossProduct ?? false;
    },
    async showCompanyBranches(offer) {
      let response = await getCompanyBranchesList(offer.companyId, this.requestData.cityInfo);

      if (response?.data?.data) {
        this.$refs.modalCompanyBranches.open(response.data.data, {
          cityName: this.requestData.cityName,
          id: this.requestData.registrationPlaceId
        });
      }
    },
    showOptionCount(offer) {
      let count = 2;
      let options = ['directSettlement', 'supportEverytime', 'medicineHelp'];

      if (offer.company?.customOptions) {
        count += offer.company.customOptions.length;
      }

      options.forEach((item) => {
        if (offer.company[item]) {
          count += 1;
        }
      });
      return count;
    },
    showRatingStars(rating) {
      let result = '';

      for (let i = 1; i < 6; i++) {
        if (rating >= i) {
          result += '<i><svg width="18" height="17" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.99984 13.417L14.1665 16.5003L12.8332 10.667L17.3332 6.66699L11.3332 6.16699L8.99984 0.666992L6.6665 6.16699L0.666504 6.66699L5.24984 10.667L3.9165 16.5003L8.99984 13.417Z" fill="#FA9B13"></path></svg></i>';
        } else {
          result += '<i><svg width="18" height="17" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.25607 12.9876L8.99774 12.8335L8.74053 12.9895L4.66713 15.4602L5.73727 10.7784L5.8039 10.4869L5.5786 10.2903L1.88543 7.06715L6.70803 6.66527L7.00889 6.64019L7.12679 6.36227L8.99984 1.94724L10.8729 6.36227L10.9908 6.64019L11.2916 6.66527L16.129 7.06838L12.501 10.2933L12.2798 10.4899L12.3457 10.7784L13.4185 15.4717L9.25607 12.9876Z" stroke="#FA9B13"></path></svg></i>';
        }
      }

      return result;
    },
    closeHint() {
      $('[data-toggle="tooltip"]').tooltip('hide');
    },
    deleteDgo(item) {
      let addPrice = parseInt(0);
      let newPrice = parseFloat(item.price);
      let newDiscountPrice = parseFloat(item.discountPrice);
      let newDynamicDiscountPrice = parseFloat(item.dynamicDiscountPrice);
      let addPriceAutolawyer = this.selectedAutolawyer[item.offerId]?.price || 0;
      let earningAutolawyer = this.selectedAutolawyer[item.offerId]?.earning || 0;


      if ((item.ex_id == 1011 /*|| item.ex_id == 1008*/) && item.customerType == 3) {
        return;
      }

      const costToSubtract = parseFloat(item.costAddedDgo || 0);

      if (costToSubtract > 0) {
        newPrice = newPrice - costToSubtract;
        if (item.discountPrice) {
          newDiscountPrice = newDiscountPrice - costToSubtract;
        }
        if (item.dynamicDiscountPrice) {
          newDynamicDiscountPrice = newDynamicDiscountPrice - costToSubtract;
        }
      }

      const earnings = item.startEarnings + earningAutolawyer;

      this.$set(item, 'earnings', earnings.toFixed(2));
      this.$set(item, 'costAddedDgo', addPrice.toFixed(2));
      this.$set(item, 'dgoPrice', null);
      this.$set(item, 'dgoId', null);
      this.$set(item, 'dgoCoverage', null);
      this.$set(item, 'dgoCompanyId', null);

      this.$set(item, 'price', newPrice.toFixed(2));

      if (item.discountPrice) {
        this.$set(item, 'discountPrice', newDiscountPrice.toFixed(2));
      }

      if (item.dynamicDiscountPrice) {
        newDynamicDiscountPrice = newDynamicDiscountPrice.toFixed(2);
        this.$set(item, 'dynamicDiscountPrice', parseFloat(newDynamicDiscountPrice));
      }

      this.$set(this.selectedDgo, item.offerId, undefined);

      $(`#selectDgo${item.offerId}`).val(0);

      // Keep absolute discount constant
      const totalFullPrice = (parseFloat(item.startPrice) || 0) + (parseFloat(item.autolawyerPrice) || 0);
      const appliedDiscount = parseFloat(item.dynamicDiscountedSum || 0);
      this.$set(item, 'dynamicEarnings', parseFloat(parseFloat(item.earnings) - appliedDiscount).toFixed(2));

      this.validatePriceSafety(item);
    },
    deleteAutolawyer(item) {
      let addPrice = parseFloat(0);
      let newPrice = parseFloat(item.price);
      let newDiscountPrice = parseFloat(item.discountPrice);
      let newDynamicDiscountPrice = parseFloat(item.dynamicDiscountPrice);
      let addPriceDgo = this.selectedDgo[item.offerId]?.cost || 0;
      let earningDgo = this.selectedDgo[item.offerId]?.earning || 0;


      if (item.costAddedAutolawyer) {
        newPrice = newPrice - parseFloat(item.costAddedAutolawyer);
        if (item.discountPrice) {
          newDiscountPrice = newDiscountPrice -  parseFloat(item.costAddedAutolawyer);
        }
        if (item.dynamicDiscountPrice) {
          newDynamicDiscountPrice = newDynamicDiscountPrice -  parseFloat(item.costAddedAutolawyer);
        }
      }

      const earnings = item.startEarnings + earningDgo;

      this.$set(item, 'earnings', earnings.toFixed(2));
      this.$set(item, 'costAddedAutolawyer', addPrice.toFixed(2));
      this.$set(item, 'autolawyerPrice', null);
      this.$set(item, 'autolawyerEarning', 0);
      this.$set(item, 'autolawyerId', null);

      this.$set(item, 'price', newPrice.toFixed(2));

      if (item.discountPrice) {
        this.$set(item, 'discountPrice', newDiscountPrice.toFixed(2));
      }

      if (item.dynamicDiscountPrice) {
        newDynamicDiscountPrice = newDynamicDiscountPrice.toFixed(2);
        this.$set(item, 'dynamicDiscountPrice', parseFloat(newDynamicDiscountPrice));
      }

      this.$set(this.selectedAutolawyer, item.offerId, undefined);

      $(`#selectAutolawyer${item.offerId}`).val(0);

      // Keep absolute discount constant
      const totalFullPrice = (parseFloat(item.startPrice) || 0) + (parseFloat(item.dgoPrice) || 0);
      const appliedDiscount = parseFloat(item.dynamicDiscountedSum || 0);
      this.$set(item, 'dynamicEarnings', parseFloat(parseFloat(item.earnings) - appliedDiscount).toFixed(2));

      this.validatePriceSafety(item);
    },
    validatePriceSafety(item) {
      if (!item.dynamicDiscountPrice) return; // Only validate safety for dynamic discounts, ignore fixed discounts

      const threshold = Number(this.user?.discountLimitThreshold) || 0;
      const basePrice = Number(item.startPrice) || Number(item.price) || 0;
      const dgoPrice = Number(item.dgoPrice) || 0;
      const lawyerPrice = Number(item.autolawyerPrice) || 0;
      const totalFullPrice = basePrice + dgoPrice + lawyerPrice;

      const dgoEarning = Number(item.dgoEarning) || 0;
      const lawyerEarning = Number(item.autolawyerEarning) || 0;
      const baseEarnings = item.startEarnings !== undefined ? Number(item.startEarnings) : (Number(item.earnings) - dgoEarning - lawyerEarning);
      const totalEarnings = baseEarnings + dgoEarning + lawyerEarning;

      const minNetto = Math.ceil(totalFullPrice - totalEarnings);
      let minAllowedPrice = minNetto;
      if (threshold > 0) {
        minAllowedPrice = Math.ceil(minNetto + (totalEarnings * threshold / 100));
      }

      const currentDiscountPrice = Number(item.dynamicDiscountPrice) || 0;

      if (currentDiscountPrice > 0 && currentDiscountPrice < minAllowedPrice) {
        // Validation breach: Bump it up to minAllowedPrice
        const correctedTotal = minAllowedPrice.toFixed(2);

        // Re-calculate percentages based on the new corrected total
        let discountedSum = (totalFullPrice - minAllowedPrice).toFixed(10);
        let discountPercent = (totalFullPrice > 0 ? (discountedSum * 100 / totalFullPrice) : 0).toFixed(10);
        let kvd = (totalEarnings - parseFloat(discountedSum)).toFixed(2);

        this.$set(item, 'dynamicDiscountPrice', parseFloat(correctedTotal));
        this.$set(item, 'dynamicDiscountPercent', parseFloat(discountPercent).toFixed(2));
        this.$set(item, 'dynamicDiscountedSum', parseFloat(discountedSum).toFixed(2));
        this.$set(item, 'dynamicEarnings', parseFloat(kvd).toFixed(2));
        this.$set(item, 'price', totalFullPrice.toFixed(2)); // price should always be full price
      }
    },
    updateMtsbuInfo() {
      setTimeout(() => {
        $('.result-item-rated').each(function () {
          $(this).find('.mtsbu-icon').attr('data-original-title', $(this).find('.mtsbu-rating').html());
        });
        if (window.screen.width < 768) {
          $('[data-toggle="tooltip"]').tooltip({ html: true, trigger: 'click' });
        } else {
          $('[data-toggle="tooltip"]').tooltip({ html: true });
        }
      }, 500);
    },
    showFranchise(offer) {
      return Number(offer.franchise);
    },
    selectDgo($event, item) {
      const selectedIndex = $event.target.options.selectedIndex;
      const targetOption = $event.target.options[selectedIndex];
      const dgoId = targetOption.getAttribute('id-dgo');
      if (dgoId) {
        const listDgo = Array.isArray(item.listDgo) ? item.listDgo : Object.values(item.listDgo || {});
        const dgoOption = listDgo.find(d => d.id == dgoId);
        this.applyDgoSelection(item, dgoOption);
      } else {
        this.deleteDgo(item);
      }
    },

    applyDgoSelection(item, dgoOption) {
      let newPrice = null;
      let newDiscountPrice = null;
      let newDynamicDiscountPrice = null;

      let addPrice = dgoOption ? parseFloat(dgoOption.cost) : 0;
      let earning = dgoOption ? parseFloat(dgoOption.earning) : 0;
      let earningAutolawyer = (this.selectedAutolawyer && this.selectedAutolawyer[item.offerId]) ? parseFloat(this.selectedAutolawyer[item.offerId].earning || 0) : 0;

      newDiscountPrice = parseFloat(item.discountPrice);
      newDynamicDiscountPrice = parseFloat(item.dynamicDiscountPrice);
      newPrice = parseFloat(item.price);

      if (item.costAddedDgo) {
        newPrice = newPrice - parseFloat(item.costAddedDgo);
        if (item.discountPrice) {
          newDiscountPrice = newDiscountPrice - parseFloat(item.costAddedDgo);
        }
        if (item.dynamicDiscountPrice) {
          newDynamicDiscountPrice = newDynamicDiscountPrice - parseFloat(item.costAddedDgo);
        }
      }

      if (item.startEarnings == undefined) {
        this.$set(item, 'startEarnings', parseFloat(item.earnings) || 0);
      }
      if (item.startPrice == undefined) {
        this.$set(item, 'startPrice', parseFloat(item.price) || 0);
      }
      if (item.startEarnings == undefined) {
        this.$set(item, 'startEarnings', parseFloat(item.earnings) || 0);
      }

      if (dgoOption) {
        this.$set(item, 'dgoId', dgoOption.id);
        this.$set(item, 'dgoCoverage', dgoOption.coverage);
        this.$set(item, 'dgoCompanyId', dgoOption.company_id);
        this.$set(item, 'dgoPrice', dgoOption.cost);
        this.$set(item, 'earnings', parseFloat(item.startEarnings + earning + earningAutolawyer).toFixed(2));
        this.$set(this.selectedDgo, item.offerId, { cost: dgoOption.cost, earning: dgoOption.earning });
      } else {
        this.$set(item, 'dgoId', null);
        this.$set(item, 'dgoCoverage', null);
        this.$set(item, 'dgoCompanyId', null);
        this.$set(item, 'dgoPrice', null);
        this.$set(item, 'earnings', parseFloat(item.startEarnings + earningAutolawyer).toFixed(2));
        this.$set(this.selectedDgo, item.offerId, undefined);
      }

      this.$set(item, 'costAddedDgo', addPrice.toFixed(2));
      this.$set(item, 'price', (newPrice + addPrice).toFixed(2));

      if (item.discountPrice) {
        this.$set(item, 'discountPrice', (newDiscountPrice + addPrice).toFixed(2));
      }

      if (item.dynamicDiscountPrice) {
        this.$set(item, 'dynamicDiscountPrice', (newDynamicDiscountPrice + addPrice).toFixed(2));
      }

      // Keep absolute discount constant
      const appliedDiscount = parseFloat(item.dynamicDiscountedSum || 0);
      this.$set(item, 'dynamicEarnings', parseFloat(parseFloat(item.earnings) - appliedDiscount).toFixed(2));

      this.validatePriceSafety(item);
    },

    autoSelectMandatoryDgo() {
      if (!this.offers) return;

      this.offers.forEach(offer => {
        if ((offer.ex_id == 1011 /*|| offer.ex_id == 1008*/) && offer.customerType == 3) {
          if (!offer.costAddedDgo || offer.costAddedDgo == 0) {
            const listDgo = Array.isArray(offer.listDgo) ? offer.listDgo : Object.values(offer.listDgo || {});
            if (listDgo && listDgo.length > 0) {
              const firstDgo = listDgo[0];
              this.applyDgoSelection(offer, firstDgo);
            }
          }
        }
      });
    },
    selectAutolawyer($event, item) {
      let newPrice = null;
      let newDiscountPrice = null;
      let newDynamicDiscountPrice = null;
      let addPrice = this.selectedAutolawyer[item.offerId]?.price || 0;
      let earning = this.selectedAutolawyer[item.offerId]?.earning || 0;

      let addPriceDgo = this.selectedDgo[item.offerId]?.cost || 0;
      let earningDgo = this.selectedDgo[item.offerId]?.earning || 0;

      addPrice = parseFloat(addPrice);
      earning = parseFloat(earning);

      newDiscountPrice = parseFloat(item.discountPrice);
      newDynamicDiscountPrice = parseFloat(item.dynamicDiscountPrice);
      newPrice = parseFloat(item.price);

      if (item.costAddedAutolawyer) {
        newPrice = newPrice - parseFloat(item.costAddedAutolawyer);
        if (item.discountPrice) {
          newDiscountPrice = newDiscountPrice - parseFloat(item.costAddedAutolawyer);
        }
        if (item.dynamicDiscountPrice) {
          newDynamicDiscountPrice = newDynamicDiscountPrice - parseFloat(item.costAddedAutolawyer);
        }
      }


      if (item.startEarnings == undefined) {
        this.$set(item, 'startEarnings', parseFloat(item.earnings) || 0);
      }
      if (item.startPrice == undefined) {
        this.$set(item, 'startPrice', parseFloat(item.price) || 0);
      }
      if (item.startEarnings == undefined) {
        this.$set(item, 'startEarnings', parseFloat(item.earnings) || 0);
      }

      if ($event.target.options.selectedIndex > 0) {
        const theTarget = $event.target.options[$event.target.options.selectedIndex];
        let autolawyerProgram = theTarget.getAttribute('program-autolawyer');

        this.$set(item, 'autolawyerId', theTarget.getAttribute('id-autolawyer'));
        //item.autolawyerOfferId = theTarget.getAttribute('offerId-autolawyer');
        this.$set(item, 'autolawyerProgram', autolawyerProgram !== null ? Number(autolawyerProgram) : null);
        this.$set(item, 'autolawyerZone', this.dataZone ?? null);
        this.$set(item, 'autolawyerAutoCategoryType', this.requestData.autoCategoryType ?? null);
        //item.autolawyerCompanyId = theTarget.getAttribute('company_id');
        this.$set(item, 'autolawyerPrice', this.selectedAutolawyer[item.offerId]?.price || theTarget.getAttribute('autolawyer-price'));
        this.$set(item, 'autolawyerEarning', earning);
        this.$set(item, 'earnings', parseFloat(item.startEarnings + earning + earningDgo).toFixed(2));
      } else {
        this.$set(item, 'autolawyerId', null);
        //item.autolawyerCoverage = null;
        //item.autolawyerCompanyId = null;
        this.$set(item, 'autolawyerPrice', null);
        this.$set(item, 'autolawyerEarning', 0);
        this.$set(item, 'autolawyerZone', null);
        this.$set(item, 'autolawyerAutoCategoryType', null);
        this.$set(item, 'autolawyerProgram', null);
        this.$set(item, 'earnings', parseFloat(item.startEarnings + earningDgo).toFixed(2));
      }

      this.$set(item, 'costAddedAutolawyer', addPrice.toFixed(2));
      this.$set(item, 'price', (newPrice + addPrice).toFixed(2));

      if (item.dynamicDiscountPrice) {
        const finalDiscountPrice = (newDynamicDiscountPrice + addPrice).toFixed(2);
        this.$set(item, 'dynamicDiscountPrice', parseFloat(finalDiscountPrice));
      }

      // Keep absolute discount constant
      const appliedDiscount = parseFloat(item.dynamicDiscountedSum || 0);
      this.$set(item, 'dynamicEarnings', parseFloat(parseFloat(item.earnings) - appliedDiscount).toFixed(2));

      this.validatePriceSafety(item);
    },
    toggleOptions(val){
      let data = val;
      const index = this.filters.optionsList.findIndex(n => n === data);
      if (index !== -1) {
        this.filters.optionsList.splice(index, 1);
      }else{
        this.filters.optionsList.push(data);
      }
    },
    fetchOffers() {
      this.$store.dispatch('GET_OSAGO_OFFERS', this.requestData);
    },

    concludeСontract(offer) {
      this.createOrder(offer);
    },
    createOrder(offer) {
      offer.prolongOrderId = this?.orderData?.offer?.prolongOrderId;
      this.$store.commit('SET_INFO_ORDER', { offer: offer, requestData: this.requestData });

      let orderData = this.getOrderData(offer);
      let orderDraft = orderData?.orderDraft;
      let data = orderData?.data;
      this.concludeOffer = true;

      if (orderDraft) {
        saveOrder(orderDraft).then(response => {
          this.concludeOffer = false;
          if (response?.data?.data[0]?.statusId === -1) {
            if (this.requestData && !this.requestData?.fromProlongation) {
              this.$store.commit('SET_FULL_INFO_ORDER', null);
            }else{
              let fullInfoOrder = JSON.parse(JSON.stringify(this.$store.state.osagoStore.fullInfoOrder));
              data.customer = fullInfoOrder.customer;
              data.car = fullInfoOrder.car;
            }
            this.orderId = response?.data?.data[0]?.id;
            data.orderId = response?.data?.data[0]?.id;
            delete data.statusId;
            delete data.orderDraft;
            this.$store.commit('SET_FULL_INFO_ORDER', data);

            let orderStepQuery = this.requestData?.fromProlongation ? { from: 'history' } : {};
            this.$router.push({ path: '/order-step', query: orderStepQuery }).catch(() => {
              this.$router.push({ path: '/order-step', query: orderStepQuery });
            });


          }

        });
      }
    },
    getOrderData(offer) {
      this.userData.address.cityId = this.dataRegistrationPlaceId;
      if (this.userData.erdpyCode) {
        this.userData.identificationCode = this.userData.erdpyCode;
      }

      let data = {
        dateFromMax: this.orderData.offer.dateFromMax ?? null,
        franchise: Number(this.orderData.offer.franchise),
        moduleId: offer.moduleId,
        companyId: this.orderData.offer.companyId,
        prolongOrderId: this.orderData?.prolongOrderId,
        //TODO писать переменные в одном стиле camelCase
        isTaxi: this.requestData.isTaxi,
        autoCategoryType: this.requestData.autoCategoryType ?? null,
        registrationPlaceId: this.orderData.requestData.registrationPlaceId ?? null,
        isEuroCar: this.orderData.requestData.isEuroCar,
        otkDate: this.orderData.requestData.otkDate || null,
        endDate: this.orderData.requestData.endDate || null,
        startDate: this.dateInfo.startDate ? moment(this.dateInfo.startDate,'DD.MM.YYYY').startOf('day').utc(true).unix() : null,
        finishAt: this.dateInfo.endDate ? moment(this.dateInfo.endDate,'DD.MM.YYYY').startOf('day').utc(true).unix() : null,
        period_id: this.dateInfo.period_id || 12,
        customerPrivilege: this.dataCustomerPrivilege || 1,
        cityRegistration: this.cityRegistration,
        car: {
          vin: this.dataCarVin,
          age: this.dataCarAge,
          birthDateOwner: this.dataCarBirthDateOwner,
          brand: this.dataCarBrand,
          model: this.dataCarModel,
          year: this.dataCarYear,
          number: this.orderData.requestData.car.number,
          kilometers: this.dataCarKilometers,
          birthdayAt: this.dataCarbirthdayAt,
          withoutVin: false,
          additional_parameters: this.dataCarAdditionalParameters
        },
        customer: this.userData,
        price: this.orderData.offer.price,
        discountPrice: this.orderData.offer?.discountPrice,
        dynamicDiscountPrice: this.orderData.offer?.dynamicDiscountPrice,
        discountPercent: this.orderData.offer?.discountPercent,
        dynamicDiscountPercent: this.orderData.offer?.dynamicDiscountPercent,
        dynamicDiscountedSum: this.orderData.offer?.dynamicDiscountedSum,
        earnings: this.orderData.offer?.earnings,
        dynamicEarnings: this.orderData.offer?.dynamicEarnings,
        offerId: this.orderData.offer.offerId,
        dgo: {
          id: this.orderData.offer.dgoId,
          compensation: this.orderData.offer.dgoCoverage,
          company_id: this.orderData.offer.dgoCompanyId,
          price: this.orderData.offer.dgoPrice,
        },
        dgoId: this.orderData.offer.dgoId,
        dgoCoverage: this.orderData.offer.dgoCoverage,
        dgoCompanyId: this.orderData.offer.dgoCompanyId,
        dgoPrice: this.orderData.offer.dgoPrice,
        autolawyer: {
          id: this.orderData.offer.autolawyerId ?? null,
          program: this.orderData.offer.autolawyerProgram ?? null,
          price: this.orderData.offer.autolawyerPrice ?? null,
          zone: this.dataZone ?? null,
          auto_category_type: this.orderData.requestData.autoCategoryType ?? null,
        },
        autolawyerId: this.orderData.offer.autolawyerId ?? null,
        //autolawyerCompanyId: this.orderData.offer.autolawyerCompanyId ?? null,
        autolawyerZone: this.dataZone ?? null,
        autolawyerPrice: this.orderData.offer.autolawyerPrice ?? null,
        autolawyerProgram: this.orderData.offer.autolawyerProgram ?? null,
        statusId: -1, // новый пустой ордер
        orderDraft: 1, //флаг для создание пустого ордера
        allowedDocuments: this.orderData.offer.available_documents ?? this.orderData.offer.allowed_documents ?? null,
      };

      if(data.dynamicDiscountedSum > 0){
        data.discountDetails = { dynamicDiscountPrice:data.dynamicDiscountPrice,
          dynamicDiscountPercent:data.dynamicDiscountPercent,
          dynamicDiscountedSum:data.dynamicDiscountedSum,
          dynamicEarnings:data.dynamicEarnings,
          earnings:data.earnings };
      }else{
        data.discountDetails = null;
      }

      let orderDraft = JSON.parse(
        JSON.stringify(
          Object.assign(data)
        )
      );
      if (this.typeDocumentId) {
        orderDraft.customer.documentation.type = this.typeDocumentId;
      }

      if (orderDraft.dgoPrice && !isNaN(parseFloat(orderDraft.dgoPrice))) {
        if (this.orderData.offer?.discountPrice) {
          orderDraft.discountPrice = parseFloat(orderDraft.discountPrice) - parseFloat(orderDraft.dgoPrice);
          orderDraft.discountPrice = orderDraft.discountPrice.toFixed(2);
          data.discountPrice = orderDraft.discountPrice;
        } else {
          orderDraft.price = parseFloat(orderDraft.price) - parseFloat(orderDraft.dgoPrice);
          orderDraft.price = orderDraft.price.toFixed(2);
          data.price = orderDraft.price;
        }
      }

      if (orderDraft.autolawyerPrice && !isNaN(parseFloat(orderDraft.autolawyerPrice))) {
        if (this.orderData.offer?.discountPrice) {
          orderDraft.discountPrice = parseFloat(orderDraft.discountPrice) - parseFloat(orderDraft.autolawyerPrice);
          orderDraft.discountPrice = orderDraft.discountPrice.toFixed(2);
          data.discountPrice = orderDraft.discountPrice;
        } else {
          orderDraft.price = parseFloat(orderDraft.price) - parseFloat(orderDraft.autolawyerPrice);
          orderDraft.price = orderDraft.price.toFixed(2);
          data.price = orderDraft.price;
        }
      }

      orderDraft.customer.dateBirth = moment(
        orderDraft.customer.dateBirth,
        'DD.MM.YYYY'
      ).utc(true).unix();
      // orderDraft.customer.documentation.dateOfIssue = moment(
      //     this.customerHaveDocumentERetiree() ? orderDraft.customer.documentation.endDateOfIssue : orderDraft.customer.documentation.dateOfIssue,
      //     "DD.MM.YYYY"
      // ).unix();//.utc(true)
      orderDraft.customer.documentation.dateOfIssue = moment(
        orderDraft.customer.documentation.dateOfIssue,
        'DD.MM.YYYY'
      ).unix();//.utc(true)
      orderDraft.customer.documentation.endDateOfIssue = orderDraft.customer.documentation.endDateOfIssue ?
        moment(orderDraft.customer.documentation.endDateOfIssue, 'DD.MM.YYYY').unix()
        : null;
      // delete data.startDate
      // delete orderDraft.startDate

      return { data: data, orderDraft: orderDraft };
    },
    viewSecondAdd(view) {
      document.querySelector('.toggler-view-default').classList.remove('active');
      document.querySelector('.toggler-view-second').classList.add('active');
      document.querySelector('.result-list').classList.add(view);
    },
    viewSecondRemove(view) {
      document.querySelector('.toggler-view-second').classList.remove('active');
      document.querySelector('.toggler-view-default').classList.add('active');
      document.querySelector('.result-list').classList.remove(view);
    },
    scrollTop: function () {
      $('html,body').stop().animate({
        scrollTop: 0
      }, 'slow', 'swing');
    },
    scrollTo(item) {
      $('.details-article-more').collapse('hide');
      let el = item;
      setTimeout(() => {
        if (!$(item).closest('.result-item ').find('.result__more a').hasClass('collapsed')) {
          if (window.screen.width > 768) {
            $('html,body').animate({
              scrollTop: $(el).closest('.result-item').offset().top - 200
            }, 500);
          } else {
            $('html,body').animate({
              scrollTop: $(el).closest('.result-item').offset().top + 250
            }, 200);
          }
        }
      }, 200);
    },
    filterStatusWrapp() {
      this.activeClassWrapp = !this.activeClassWrapp;

      if (this.activeClassWrapp) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = '';
      }
    },
    filterDiscard() {
      this.filters.company = [];
      this.filters.priceDiapason.min = '';
      this.filters.priceDiapason.max = '';
      this.filters.franchises = [];
      this.filters.directSettlement = false;
      this.filters.supportEverytime = false;
      this.filters.medicineHelp = false;
      this.filters.optionsList = [];
      this.filters.customOptions = [];
    },
    sortOffers() {
      let result = this.$store.state.osagoStore.osagoOffers;

      if (result) {
        result.forEach(item => {
          if (item.startEarnings === undefined) {
            this.$set(item, 'startEarnings', parseFloat(item.earnings) || 0);
          }
          if (item.startPrice === undefined) {
            this.$set(item, 'startPrice', parseFloat(item.price) || 0);
          }
          if (item.dynamicDiscountedSum === undefined) {
              this.$set(item, 'dynamicDiscountedSum', 0);
          }
        });

        if (this.filters.directSettlement) {
          result = result.filter(item => {
            return item.company.directSettlement === 1;
          });
        }

        if (this.filters.supportEverytime) {
          result = result.filter(item => {
            return item.company.supportEverytime === 1;
          });
        }

        if (this.filters.medicineHelp) {
          result = result.filter(item => {
            return item.company.medicineHelp === 1;
          });
        }

        if (this.filters.customOptions.length > 0) {
          result = result.filter(item => {
            if (item.company.customOptions == null) {
              return false;
            }

            return item.company.customOptions.some(customOption => {
              return this.filters.customOptions.includes(customOption);
            });
          });
        }

        if (this.filters.company.length > 0) {
          result = result.filter(function (item) {
            return this.filters.company.includes(item.companyNamePublic);
          }, this);
        }

        if (this.filters.franchises.length > 0) {
          result = result.filter(item => {
            return this.filters.franchises.includes(item.franchise);
          });
        }

        if (this.filters.priceDiapason.min > 0) {
          result = result.filter(item => {
            return item.price >= this.filters.priceDiapason.min;
          });
        }

        if (this.filters.priceDiapason.max > 0) {
          result = result.filter(item => {
            return item.price <= this.filters.priceDiapason.max;
          });
        }

        switch (this.filters.type) {
          case 'lowcost':
            result = result.sort(function (a, b) {
              let aCostAddedDgo = isNaN(parseInt(a.costAddedDgo)) ? 0 : parseInt(a.costAddedDgo);
              let bCostAddedDgo = isNaN(parseInt(b.costAddedDgo)) ? 0 : parseInt(b.costAddedDgo);
              if ((a.price - aCostAddedDgo) < (b.price - bCostAddedDgo)) {
                return -1;
              }
              if (b.price < a.price) {
                return 1;
              }
              return 0;
            });
            break;
          case 'earnings':
            result = result.sort(function (a, b) {
              if ((a.earnings) < (b.earnings)) {
                return -1;
              }
              if (b.earnings < a.earnings) {
                return 1;
              }
              return 0;
            });
            break;
          default:
            if (this.filters.sort === 'lowcost') {
              result = result.sort(function (a, b) {
                let aCostAddedDgo = isNaN(parseInt(a.costAddedDgo)) ? 0 : parseInt(a.costAddedDgo);
                let bCostAddedDgo = isNaN(parseInt(b.costAddedDgo)) ? 0 : parseInt(b.costAddedDgo);
                if ((a.price - aCostAddedDgo) < (b.price - bCostAddedDgo)) {
                  return -1;
                }
                if (b.price < a.price) {
                  return 1;
                }
                return 0;
              });
            } else if (this.filters.sort === 'price-earnings') {
              result = result.sort(function (a, b) {
                let aCostAddedDgo = isNaN(parseInt(a.costAddedDgo)) ? 0 : parseInt(a.costAddedDgo);
                let bCostAddedDgo = isNaN(parseInt(b.costAddedDgo)) ? 0 : parseInt(b.costAddedDgo);
                if ((a.price - aCostAddedDgo) < (b.price - bCostAddedDgo)) {
                  return -1;
                }
                if (b.price < a.price) {
                  return 1;
                }
                return 0;
              });
              result = result.sort(function (a, b) {
                if (Math.round((a.earnings / a.price) * 100) > Math.round((b.earnings / b.price) * 100)) {
                  return -1;
                }

                if (Math.round((b.earnings / b.price) * 100) > Math.round((a.earnings / a.price) * 100)) {
                  return 1;
                }
                return 0;
              });
            } else if (this.filters.sort === 'earnings') {
              result = result.sort(function (a, b) {
                if (a.earnings > b.earnings) {
                  return -1;
                }

                if (b.earnings > a.earnings) {
                  return 1;
                }
                return 0;
              });
            } else if (this.filters.sort === 'net-pay') {
              result = result.sort(function (a, b) {
                let aNetPay = 0;
                let bNetPay = 0;

                if (a.discountPrice > 0) {
                  aNetPay = a.discountPrice - a.earnings;
                } else {
                  aNetPay = a.price - a.earnings;
                }

                if (b.discountPrice > 0) {
                  bNetPay = b.discountPrice - b.earnings;
                } else {
                  bNetPay = b.price - b.earnings;
                }

                if (aNetPay > bNetPay) {
                  return 1;
                }

                if (aNetPay < bNetPay) {
                  return -1;
                }

                return 0;
              });
            } else {
              result = result.sort(function (a, b) {
                if (a.companyNamePublic < b.companyNamePublic) {
                  return -1;
                }

                if (b.companyNamePublic < a.companyNamePublic) {
                  return 1;
                }

                return 0;
              });
            }
            break;
        }

        $('[data-toggle="tooltip"]').tooltip({
          html: true
        });

        this.updateMtsbuInfo();

        this.offers = result;
        this.autoSelectMandatoryDgo();
      }
    },
  },
  mixins: [userSettings, displaySettings, discountMixin],
};

$(document).on('click', '.filter-content-wrapp .dropdown-menu', function (e) {
  $(this).hasClass('show') && e.stopPropagation();
});

$(document).on('click', '.more[aria-expanded="true"]', function () {
  let target = $(this).closest('.result-item');
  $([document.documentElement, document.body]).animate({
    scrollTop: $(target).offset().top - 100
  }, 500);
});
</script>
<style>
.nice-select .list {
    width: 300%;
}
.result-item .form-group__descr{
  font-size: 14px;
  color: #dc850a;
}
.el-loading-mask {
    opacity: 0.5;
}
.result__param.param-options .slider-container {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.result__param.param-options .slider-btn {
  background: none;
  border: none;
  font-size: 20px;
  cursor: pointer;
}

.result__param.param-options .slider-content {
  text-align: center;
  max-width: 300px;
  cursor: pointer; /* Указатель на элемент, чтобы сигнализировать пользователю */
}

.result__param.param-options .arrow-container {
  height: 50px;
  width: 40px;
  display: flex;
  align-items: center;
  justify-content: left;
}

.result__param.param-options .arrow {
  height: 45px;
  width: auto;
  fill: #ffad3d;
  shape-rendering: geometricPrecision;
  transform: translateZ(0);
  image-rendering: optimizeQuality;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
}

@media screen and (max-width: 768px){
  .result-item .result__param.param-options {
    width: 100%;
  }
  .result-item .result__param.param-options .slider-container{
    width: 100%;
  }
  .result-item .result__param.param-options .slider-content{
    width: 100%;
    max-width: none;
    text-align: left;
  }
}
</style>
